export const SidebarData1 = {
  landingpage: [
    {
      tittle: "Modules",
      hasSubRoute: true,
      icon: "layout-grid",
      showSubRoute: true,
      subRoutes: [
        // {
        //   tittle: "Rollcall",
        //   hasSubRoute: false,
        //   showSubRoute: false,
        //   route: "/rollcall/dashboard",
        // },
        // {
        //   tittle: "Payroll",
        //   hasSubRoute: false,
        //   showSubRoute: false,
        //   route: "/payroll/dashboard",
        // },
        // {
        //   tittle: "Applicant Tracking",
        //   hasSubRoute: false,
        //   showSubRoute: false,
        //   base: "application",
        //   route: "applicantTracking/dashboard",
        // },
        {
          tittle: "HR",
          hasSubRoute: false,
          icon: "layout-grid",
          showSubRoute: false,
          route: "/hr",
          // subRoutes: [
          //   {
          //     tittle: "Rollcall",
          //     hasSubRoute: false,
          //     showSubRoute: false,
          //     route: "/rollcall/dashboard",
          //   },
          //   {
          //     tittle: "Payroll",
          //     hasSubRoute: false,
          //     showSubRoute: false,
          //     route: "/payroll/dashboard",
          //   },
          //   {
          //     tittle: "Applicant Tracking",
          //     hasSubRoute: false,
          //     showSubRoute: false,
          //     base: "application",
          //     route: "applicantTracking/dashboard",
          //   },
          // ],
        },
        {
          tittle: "Inventory",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/inventory/dashboard",
          subRoutes: [],
        },
        {
          tittle: "Asset Management",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/assetmgt/dashboard",
        },
        {
          tittle: "Project Management",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/projectmgt/dashboard",
        },
        {
          tittle: "CRM",
          hasSubRoute: false,
          showSubRoute: false,
          route: "crm/dashboard",
        },
        {
          tittle: "Production",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/bom/dashboard",
        },

        {
          tittle: "Admin",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/landingpage",
        },
        {
          tittle: "Misc",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/landingpage",
        },
        {
          tittle: "Gallary",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/landingpage",
        },
      ],
    },
    // {
    //   tittle: "HR",
    //   hasSubRoute: true,
    //   icon: "layout-grid",
    //   showSubRoute: false,
    //   subRoutes: [
    //     {
    //       tittle: "Rollcall",
    //       hasSubRoute: true,
    //       showSubRoute: false,
    //       route: "/rollcall/dashboard",
    //       subRoutes: [
    //         {
    //           tittle: "Employee",
    //           hasSubRoute: true,
    //           icon: "users",
    //           showSubRoute: false,

    //           subRoutes: [
    //             {
    //               tittle: "Registrations",
    //               hasSubRoute: false,
    //               showSubRoute: true,
    //               route: "/rollcall/registrations",
    //               subRoutes: [],
    //             },
    //             {
    //               tittle: "Rejoin Employes",
    //               hasSubRoute: false,
    //               showSubRoute: false,
    //               route: "/rollcall/rejoin-employees",
    //               subRoutes: [],
    //             },
    //             {
    //               tittle: "Employee List",
    //               hasSubRoute: false,
    //               showSubRoute: false,
    //               route: "/rollcall/employees",
    //               subRoutes: [],
    //             },
    //             {
    //               tittle: "Additional Details",
    //               hasSubRoute: false,
    //               showSubRoute: false,
    //               route: "/rollcall/additional-details",
    //               subRoutes: [],
    //             },
    //           ],
    //         },
    //         {
    //           tittle: "Manual Attandance",
    //           hasSubRoute: false,
    //           icon: "layout-grid",
    //           showSubRoute: false,
    //           route: "/rollcall/manual-attendance",
    //         },
    //         {
    //           tittle: "Configrations",
    //           hasSubRoute: true,
    //           icon: "users",
    //           showSubRoute: false,
    //           // activeRoute: 'Registrations',
    //           subRoutes: [
    //             {
    //               tittle: "Holidays",
    //               hasSubRoute: false,
    //               showSubRoute: true,
    //               route: "/rollcall/holidays",
    //               subRoutes: [],
    //             },
    //             {
    //               tittle: "Department",
    //               hasSubRoute: false,
    //               showSubRoute: false,
    //               route: "/rollcall/departments",
    //               subRoutes: [],
    //             },
    //             {
    //               tittle: "Employee Acess",
    //               hasSubRoute: false,
    //               showSubRoute: false,
    //               route: "/rollcall/employee-access",
    //               subRoutes: [],
    //             },
    //             // {
    //             //   tittle: "User Acess",
    //             //   hasSubRoute: false,
    //             //   showSubRoute: false,
    //             //   route: "/rollcall/employee",
    //             //   subRoutes: [],
    //             // },
    //             {
    //               tittle: "Assign shift",
    //               hasSubRoute: false,
    //               showSubRoute: false,
    //               route: "/rollcall/assign-shifts",
    //               subRoutes: [],
    //             },
    //           ],
    //         },
    //         {
    //           tittle: "Monthly Reports",
    //           hasSubRoute: true,
    //           icon: "users",
    //           showSubRoute: false,
    //           // activeRoute: 'Registrations',
    //           subRoutes: [
    //             {
    //               tittle: "Monthly Register",
    //               hasSubRoute: false,
    //               showSubRoute: true,
    //               route: "/rollcall/holidays",
    //               subRoutes: [],
    //             },
    //             {
    //               tittle: "Monthly Summary",
    //               hasSubRoute: false,
    //               showSubRoute: false,
    //               route: "rollcall/reports/706",
    //               subRoutes: [],
    //             },
    //             {
    //               tittle: "Leave Details",
    //               hasSubRoute: false,
    //               showSubRoute: false,
    //               route: "rollcall/reports/707",
    //               subRoutes: [],
    //             },
    //           ],
    //         },
    //         {
    //           tittle: "Leaves",
    //           hasSubRoute: true,
    //           icon: "users",
    //           showSubRoute: false,
    //           // activeRoute: 'Registrations',
    //           subRoutes: [
    //             {
    //               tittle: "Apply Leave",
    //               hasSubRoute: false,
    //               showSubRoute: true,
    //               route: "/rollcall/leaves",
    //               subRoutes: [],
    //             },
    //           ],
    //         },

    //       ]
    //     },
    //     {
    //       tittle: "Payroll",
    //       hasSubRoute: true,
    //       showSubRoute: false,
    //       route: "/payroll/dashboard",
    //       subRoutes: [
    //         {
    //           tittle: "Employee",
    //           hasSubRoute: true,
    //           icon: "users",
    //           showSubRoute: false,

    //           subRoutes: [
    //             {
    //               tittle: "Registrations",
    //               hasSubRoute: false,
    //               showSubRoute: true,
    //               route: "/rollcall/registrations",
    //               subRoutes: [],
    //             },
    //             {
    //               tittle: "Rejoin Employes",
    //               hasSubRoute: false,
    //               showSubRoute: false,
    //               route: "/rollcall/rejoin-employees",
    //               subRoutes: [],
    //             },
    //             {
    //               tittle: "Employee List",
    //               hasSubRoute: false,
    //               showSubRoute: false,
    //               route: "/rollcall/employees",
    //               subRoutes: [],
    //             },
    //             {
    //               tittle: "Additional Details",
    //               hasSubRoute: false,
    //               showSubRoute: false,
    //               route: "/rollcall/additional-details",
    //               subRoutes: [],
    //             },
    //           ],
    //         },
    //         {
    //           tittle: "Manual Attandance",
    //           hasSubRoute: false,
    //           icon: "layout-grid",
    //           showSubRoute: false,
    //           route: "/rollcall/manual-attendance",
    //         },
    //         {
    //           tittle: "Configrations",
    //           hasSubRoute: true,
    //           icon: "users",
    //           showSubRoute: false,
    //           // activeRoute: 'Registrations',
    //           subRoutes: [
    //             {
    //               tittle: "Holidays",
    //               hasSubRoute: false,
    //               showSubRoute: true,
    //               route: "/rollcall/holidays",
    //               subRoutes: [],
    //             },
    //             {
    //               tittle: "Department",
    //               hasSubRoute: false,
    //               showSubRoute: false,
    //               route: "/rollcall/departments",
    //               subRoutes: [],
    //             },
    //             {
    //               tittle: "Employee Acess",
    //               hasSubRoute: false,
    //               showSubRoute: false,
    //               route: "/rollcall/employee-access",
    //               subRoutes: [],
    //             },
    //             // {
    //             //   tittle: "User Acess",
    //             //   hasSubRoute: false,
    //             //   showSubRoute: false,
    //             //   route: "/rollcall/employee",
    //             //   subRoutes: [],
    //             // },
    //             {
    //               tittle: "Assign shift",
    //               hasSubRoute: false,
    //               showSubRoute: false,
    //               route: "/rollcall/assign-shifts",
    //               subRoutes: [],
    //             },
    //           ],
    //         },
    //         {
    //           tittle: "Monthly Reports",
    //           hasSubRoute: true,
    //           icon: "users",
    //           showSubRoute: false,
    //           // activeRoute: 'Registrations',
    //           subRoutes: [
    //             {
    //               tittle: "Monthly Register",
    //               hasSubRoute: false,
    //               showSubRoute: true,
    //               route: "/rollcall/holidays",
    //               subRoutes: [],
    //             },
    //             {
    //               tittle: "Monthly Summary",
    //               hasSubRoute: false,
    //               showSubRoute: false,
    //               route: "rollcall/reports/706",
    //               subRoutes: [],
    //             },
    //             {
    //               tittle: "Leave Details",
    //               hasSubRoute: false,
    //               showSubRoute: false,
    //               route: "rollcall/reports/707",
    //               subRoutes: [],
    //             },
    //           ],
    //         },
    //         {
    //           tittle: "Leaves",
    //           hasSubRoute: true,
    //           icon: "users",
    //           showSubRoute: false,
    //           // activeRoute: 'Registrations',
    //           subRoutes: [
    //             {
    //               tittle: "Apply Leave",
    //               hasSubRoute: false,
    //               showSubRoute: true,
    //               route: "/rollcall/leaves",
    //               subRoutes: [],
    //             },
    //           ],
    //         },
    //         {
    //           tittle: "Reports",
    //           hasSubRoute: true,
    //           icon: "users",
    //           showSubRoute: false,
    //           // activeRoute: 'Registrations',
    //           subRoutes: [
    //             {
    //               tittle: "Punch by Day",
    //               hasSubRoute: false,
    //               showSubRoute: true,
    //               route: "rollcall/reports/701",
    //               subRoutes: [],
    //             },
    //             {
    //               tittle: "Dailt Attendance",
    //               hasSubRoute: false,
    //               showSubRoute: false,
    //               route: "rollcall/reports/702",
    //               subRoutes: [],
    //             },
    //             {
    //               tittle: "Break Summary",
    //               hasSubRoute: false,
    //               showSubRoute: false,
    //               route: "rollcall/reports/703",
    //               subRoutes: [],
    //             },
    //             {
    //               tittle: "Break Details",
    //               hasSubRoute: false,
    //               showSubRoute: false,
    //               route: "rollcall/reports/704",
    //               subRoutes: [],
    //             },
    //             {
    //               tittle: "Attendance In/Out",
    //               hasSubRoute: false,
    //               showSubRoute: false,
    //               route: "rollcall/reports/705",
    //               subRoutes: [],
    //             },
    //             // {
    //             //   tittle: "Monthly Summary",
    //             //   hasSubRoute: false,
    //             //   showSubRoute: false,
    //             //   route: "rollcall/reports/706",
    //             //   subRoutes: [],
    //             // },
    //           ],
    //         },
    //       ]

    //     },
    //     {
    //       tittle: "Applicant Tracking",
    //       hasSubRoute: true,
    //       showSubRoute: false,
    //       base: "application",
    //       route: "applicantTracking/dashboard",
    //       subRoutes: [
    //         {
    //           tittle: "Applicants",
    //           hasSubRoute: false,
    //           icon: "users",
    //           showSubRoute: false,
    //           route: "/applicantTracking/applicants",
    //         },
    //         {
    //           tittle: "Clients",
    //           hasSubRoute: false,
    //           icon: "users",
    //           showSubRoute: false,
    //           route: "/applicantTracking/clients",
    //         },
    //         {
    //           tittle: "Jobs posted",
    //           hasSubRoute: false,
    //           icon: "users",
    //           showSubRoute: false,
    //           route: "/applicantTracking/jobs",
    //         },
    //         {
    //           tittle: "Settings",
    //           hasSubRoute: true,
    //           icon: "users",
    //           showSubRoute: false,
    //           // route: "/applicantTracking/jobs",
    //           subRoutes: [
    //             {
    //               tittle: "Job Categories",
    //               hasSubRoute: false,
    //               showSubRoute: false,
    //               route: "/applicantTracking/jobcategories",
    //               subRoutes: [],
    //             },
    //             {
    //               tittle: "Job Skills",
    //               hasSubRoute: false,
    //               showSubRoute: false,
    //               route: "/applicantTracking/jobskills",
    //             },
    //             {
    //               tittle: "Placements",
    //               hasSubRoute: false,
    //               showSubRoute: false,
    //               route: "/applicantTracking/placements",
    //             },
    //             {
    //               tittle: "Email Notfication",
    //               hasSubRoute: false,
    //               showSubRoute: false,
    //               route: "/applicantTracking/emailnotfication",
    //             },
    //             {
    //               tittle: "Interview Feedback",
    //               hasSubRoute: false,
    //               showSubRoute: false,
    //               route: "/applicantTracking/interviewfeedback",
    //             },
    //           ]
    //         },
    //       ]
    //     },
    //   ],
    // },
    {
      tittle: "Roll call",
      hasSubRoute: true,
      icon: "calendar",
      showSubRoute: false,
      route: "/rollcall/dashboard",
      subRoutes: [
        {
          tittle: "Employee",
          hasSubRoute: true,
          icon: "users",
          showSubRoute: false,

          subRoutes: [
            {
              tittle: "Show All",
              hasSubRoute: false,
              showSubRoute: false,
              route: "/rollcall/employees",
              subRoutes: [],
            },
            {
              tittle: "Additional Details",
              hasSubRoute: false,
              showSubRoute: false,
              route: "/rollcall/additional-details",
              subRoutes: [],
            },
          ],
        },
        {
          tittle: "Permission",
          hasSubRoute: true,
          icon: "progress-check",
          showSubRoute: false,
          route: "/rollcall/manual-attendance",
          subRoutes: [
            {
              tittle: "Manual Attendance",
              hasSubRoute: false,
              showSubRoute: true,
              route: "/rollcall/manual-attendance",
              subRoutes: [],
            },
            {
              tittle: "Assign shift",
              hasSubRoute: false,
              showSubRoute: false,
              route: "/rollcall/assign-shifts",
              subRoutes: [],
            },
            {
              tittle: "Employee Acess",
              hasSubRoute: false,
              showSubRoute: false,
              route: "/rollcall/employee-access",
              subRoutes: [],
            },
            {
              tittle: "Registrations",
              hasSubRoute: false,
              showSubRoute: true,
              route: "/rollcall/registrations",
              subRoutes: [],
            },
            {
              tittle: "Rejoin Employes",
              hasSubRoute: false,
              showSubRoute: false,
              route: "/rollcall/rejoin-employees",
              subRoutes: [],
            },
          ],
        },
        {
          tittle: "Configrations",
          hasSubRoute: true,
          icon: "settings-cog",
          showSubRoute: false,
          // activeRoute: 'Registrations',
          subRoutes: [
            {
              tittle: "Holidays",
              hasSubRoute: false,
              showSubRoute: true,
              route: "/rollcall/holidays",
              subRoutes: [],
            },
            {
              tittle: "Department",
              hasSubRoute: false,
              showSubRoute: false,
              route: "/rollcall/departments",
              subRoutes: [],
            },
            {
              tittle: "Leave Type",
              hasSubRoute: false,
              showSubRoute: false,
              route: "/rollcall/leavetypes",
              subRoutes: [],
            },

            // {
            //   tittle: "User Acess",
            //   hasSubRoute: false,
            //   showSubRoute: false,
            //   route: "/rollcall/employee",
            //   subRoutes: [],
            // },
          ],
        },
        // {
        //   tittle: "Monthly Reports",
        //   hasSubRoute: true,
        //   icon: "chart-line",
        //   showSubRoute: false,
        //   // activeRoute: 'Registrations',
        //   subRoutes: [
        //     {
        //       tittle: "Monthly Register",
        //       hasSubRoute: false,
        //       showSubRoute: true,
        //       route: "/rollcall/holidays",
        //       subRoutes: [],
        //     },
        //     {
        //       tittle: "Monthly Summary",
        //       hasSubRoute: false,
        //       showSubRoute: false,
        //       route: "rollcall/reports/706",
        //       subRoutes: [],
        //     },
        //     {
        //       tittle: "Leave Details",
        //       hasSubRoute: false,
        //       showSubRoute: false,
        //       route: "rollcall/reports/707",
        //       subRoutes: [],
        //     },
        //   ],
        // },
        {
          tittle: "Leave Management",
          hasSubRoute: true,
          icon: "calendar",
          showSubRoute: false,
          // activeRoute: 'Registrations',
          subRoutes: [
            {
              tittle: "Apply ",
              hasSubRoute: false,
              showSubRoute: true,
              route: "/rollcall/leaves",
              subRoutes: [],
            },
            {
              tittle: " Summary",
              hasSubRoute: false,
              showSubRoute: true,
              route: "/rollcall/leavesummary",
              subRoutes: [],
            },
            {
              tittle: " Accruals",
              hasSubRoute: false,
              showSubRoute: true,
              route: "/rollcall/leaveaccurals",
              subRoutes: [],
            },
            {
              tittle: " Report",
              hasSubRoute: false,
              showSubRoute: false,
              route: "rollcall/reports/707",
              subRoutes: [],
            },
          ],
        },
        {
          tittle: "Reports",
          hasSubRoute: true,
          icon: "chart-line",
          showSubRoute: false,
          subRoutes: [
            {
              tittle: "Day",
              hasSubRoute: true,
              icon: "chart-line",
              showSubRoute: false,
              activeRoute: "rollcall/reports/701",
              subRoutes: [
                {
                  tittle: "Punch by Day",
                  hasSubRoute: false,
                  showSubRoute: true,
                  route: "rollcall/reports/701",
                  subRoutes: [],
                },
                {
                  tittle: "Daily Attendance",
                  hasSubRoute: false,
                  showSubRoute: false,
                  route: "rollcall/reports/702",
                  subRoutes: [],
                },
                {
                  tittle: "Break Summary",
                  hasSubRoute: false,
                  showSubRoute: false,
                  route: "rollcall/reports/703",
                  subRoutes: [],
                },
                {
                  tittle: "Break Details",
                  hasSubRoute: false,
                  showSubRoute: false,
                  route: "rollcall/reports/704",
                  subRoutes: [],
                },
                {
                  tittle: "Break Alerts",
                  hasSubRoute: false,
                  showSubRoute: false,
                  route: "rollcall/reports/704",
                  subRoutes: [],
                },
                {
                  tittle: "Attendance In/Out",
                  hasSubRoute: false,
                  showSubRoute: false,
                  route: "rollcall/reports/705",
                  subRoutes: [],
                },
                {
                  tittle: "Mobile Swipes",
                  hasSubRoute: false,
                  showSubRoute: false,
                  route: "rollcall/reports/704",
                  subRoutes: [],
                },
                {
                  tittle: "Wage Details",
                  hasSubRoute: false,
                  showSubRoute: false,
                  route: "rollcall/reports/704",
                  subRoutes: [],
                },
                {
                  tittle: "Wage Summary",
                  hasSubRoute: false,
                  showSubRoute: false,
                  route: "rollcall/reports/705",
                  subRoutes: [],
                },
                // {
                //   tittle: "Monthly Summary",
                //   hasSubRoute: false,
                //   showSubRoute: false,
                //   route: "rollcall/reports/706",
                //   subRoutes: [],
                // },
                // {
                //   tittle: "Monthly Register",
                //   hasSubRoute: false,
                //   showSubRoute: true,
                //   route: "/rollcall/holidays",
                //   subRoutes: [],
                // },
                // {
                //   tittle: "Monthly Summary",
                //   hasSubRoute: false,
                //   showSubRoute: false,
                //   route: "rollcall/reports/706",
                //   subRoutes: [],
                // },
              ],
            },
            {
              tittle: "Monthly",
              hasSubRoute: true,
              icon: "chart-line",
              showSubRoute: false,
              activeRoute: "rollcall/reports/701",
              subRoutes: [
                {
                  tittle: "Monthly Summary",
                  hasSubRoute: false,
                  showSubRoute: false,
                  route: "rollcall/reports/706",
                  subRoutes: [],
                },
                // {
                //   tittle: "Monthly Summary",
                //   hasSubRoute: false,
                //   showSubRoute: false,
                //   route: "rollcall/reports/706",
                //   subRoutes: [],
                // },
                {
                  tittle: "Monthly Register",
                  hasSubRoute: false,
                  showSubRoute: true,
                  route: "rollcall/reports/706",
                  subRoutes: [],
                },
              ],
            },
          ],
        },
      ],
    },
    {
      tittle: "Application Tracking",
      hasSubRoute: true,
      icon: "progress-check",
      showSubRoute: false,
      route: "/applicantTracking/dashboard",
      subRoutes: [
        {
          tittle: "Applicants",
          hasSubRoute: false,
          icon: "users",
          showSubRoute: false,
          route: "/applicantTracking/applicants",
        },
        {
          tittle: "Clients",
          hasSubRoute: false,
          icon: "users",
          showSubRoute: false,
          route: "/applicantTracking/clients",
        },
        {
          tittle: "Jobs posted",
          hasSubRoute: false,
          icon: "users",
          showSubRoute: false,
          route: "/applicantTracking/jobs",
        },
        {
          tittle: "Settings",
          hasSubRoute: true,
          icon: "users",
          showSubRoute: false,
          // route: "/applicantTracking/jobs",
          subRoutes: [
            {
              tittle: "Job Categories",
              hasSubRoute: false,
              showSubRoute: false,
              route: "/applicantTracking/jobcategories",
              subRoutes: [],
            },
            {
              tittle: "Job Skills",
              hasSubRoute: false,
              showSubRoute: false,
              route: "/applicantTracking/jobskills",
            },
            {
              tittle: "Placements",
              hasSubRoute: false,
              showSubRoute: false,
              route: "/applicantTracking/placements",
            },
            {
              tittle: "Email Notfication",
              hasSubRoute: false,
              showSubRoute: false,
              route: "/applicantTracking/emailnotfication",
            },
            {
              tittle: "Interview Feedback",
              hasSubRoute: false,
              showSubRoute: false,
              route: "/applicantTracking/interviewfeedback",
            },
          ],
        },
      ],
    },
    {
      tittle: "CRM",
      hasSubRoute: true,
      icon: "brand-unity",
      showSubRoute: false,
      route: "crm/dashboard",
      activeRoute: "crm/dashboard",
      subRoutes: [
        {
          tittle: "Leads",
          hasSubRoute: false,
          showSubRoute: true,
          route: "/crm/leads",
          subRoutes: [],
        },
        {
          tittle: "Customers",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/crm/customers",
          subRoutes: [],
        },
        {
          tittle: "Product",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/product-list",
          subRoutes: [],
        },
        {
          tittle: "Projects",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/product-list",
          subRoutes: [],
        },
        {
          tittle: "Sales",
          hasSubRoute: true,
          showSubRoute: false,
          // route: "/category-list",
          subRoutes: [
            {
              tittle: "Proposal",
              hasSubRoute: false,
              showSubRoute: false,
              route: "/crm/proposals",
            },
            {
              tittle: "Estimate",
              hasSubRoute: false,
              showSubRoute: false,
              route: "/crm/estimates",
            },
            {
              tittle: "invoice",
              hasSubRoute: false,
              showSubRoute: false,
              route: "/crm/invoices",
              subRoutes: [],
            },
            {
              tittle: "Credit Note",
              hasSubRoute: false,
              showSubRoute: false,
              route: "/crm/creditnotes",
            },
            {
              tittle: "Payment",
              hasSubRoute: false,
              showSubRoute: false,
              route: "/crm/payments",
            },
          ],
        },
      ],
      //   {
      //     tittle: "Sub Category",
      //     hasSubRoute: false,
      //     showSubRoute: false,
      //     route: "/sub-categories",
      //     subRoutes: [],
      //   },
      //   {
      //     tittle: "Brands",
      //     hasSubRoute: false,
      //     showSubRoute: false,
      //     route: "/brand-list",
      //     subRoutes: [],
      //   },
      //   {
      //     tittle: "Units",
      //     hasSubRoute: false,
      //     showSubRoute: false,
      //     route: "/units",
      //     subRoutes: [],
      //   },
      //   {
      //     tittle: "Variant Attributes",
      //     hasSubRoute: false,
      //     showSubRoute: false,
      //     route: "/variant-attributes",
      //     subRoutes: [],
      //   },
      //   {
      //     tittle: "Warranties",
      //     hasSubRoute: false,
      //     showSubRoute: false,
      //     route: "/warranty",
      //     subRoutes: [],
      //   },
      //   {
      //     tittle: "Print Barcode",
      //     hasSubRoute: false,
      //     showSubRoute: false,
      //     route: "/barcode",
      //     subRoutes: [],
      //   },
      //   {
      //     tittle: "Print QR Code",
      //     hasSubRoute: false,
      //     showSubRoute: false,
      //     route: "/qrcode",
      //     subRoutes: [],
      //   },
      // ],
    },
    {
      tittle: "Inventory",
      hasSubRoute: true,
      icon: "device-analytics",
      showSubRoute: false,
      activeRoute: "/inventory/dashboard",
      route: "/inventory/dashboard",
      subRoutes: [
        {
          tittle: "Purchases",
          hasSubRoute: true,
          icon: "users",
          showSubRoute: false,
          subRoutes: [
            {
              tittle: "Supplier",
              hasSubRoute: false,
              showSubRoute: true,
              route: "/inventory/suppliers",
              subRoutes: [],
            },
            {
              tittle: "Purchase Request",
              hasSubRoute: false,
              showSubRoute: false,
              route: "/inventory/purchase-request",
              subRoutes: [],
            },
            {
              tittle: "Purchase Order",
              hasSubRoute: false,
              showSubRoute: false,
              route: "/inventory/purchase-list",
              subRoutes: [],
            },
            {
              tittle: "Invoice",
              hasSubRoute: false,
              showSubRoute: false,
              route: "/inventory/invoice-list",
              subRoutes: [],
            },
            {
              tittle: "Supplier Payment",
              hasSubRoute: false,
              showSubRoute: false,
              route: "/inventory/supplier-payments",
              subRoutes: [],
            },
          ],
        },
        {
          tittle: "Stock",
          hasSubRoute: true,
          icon: "users",
          showSubRoute: false,

          subRoutes: [
            {
              tittle: "Indent",
              hasSubRoute: false,
              showSubRoute: true,
              route: "/inventory/indent",
              subRoutes: [],
            },
            {
              tittle: "Local Purchase indents",
              hasSubRoute: false,
              showSubRoute: false,
              route: "/inventory/local-indent/",
              subRoutes: [],
            },
            {
              tittle: "Transfer",
              hasSubRoute: false,
              showSubRoute: false,
              route: "/inventory/stock-transfer",
              subRoutes: [],
            },
            {
              tittle: "Adjustment",
              hasSubRoute: false,
              showSubRoute: false,
              route: "inventory/stock-adjustment",
              subRoutes: [],
            },
          ],
        },
        // {
        //   tittle: "Inventory Reports",
        //   hasSubRoute: true,
        //   icon: "users",
        //   showSubRoute: true,
        //   subRoutes: [
        //     {
        //       tittle: "Stock Reports",
        //       hasSubRoute: true,
        //       showSubRoute: true,
        //       subRoutes: [
        //         {
        //           tittle: "Low Stock",
        //           hasSubRoute: false,
        //           showSubRoute: false,
        //           route: "/inventory/reports/301",
        //           subRoutes: [],
        //         },
        //         {
        //           tittle: "Current Stock",
        //           hasSubRoute: false,
        //           showSubRoute: false,
        //           route: "/inventory/reports/302",
        //           subRoutes: [],
        //         },
        //         {
        //           tittle: "Stock Worth",
        //           hasSubRoute: false,
        //           showSubRoute: false,
        //           route: "/inventory/reports/303",
        //           subRoutes: [],
        //         },
        //         {
        //           tittle: "Short Supply",
        //           hasSubRoute: false,
        //           showSubRoute: false,
        //           route: "/inventory/reports/304",
        //           subRoutes: [],
        //         },
        //       ],
        //     },
        //     {
        //       tittle: "Inventory Reports",
        //       hasSubRoute: true,
        //       showSubRoute: true,
        //       subRoutes: [
        //         {
        //           tittle: "Request By product",
        //           hasSubRoute: false,
        //           showSubRoute: false,
        //           route: "/inventory/reports/501",
        //           subRoutes: [],
        //         },
        //         {
        //           tittle: "Purchase Request",
        //           hasSubRoute: false,
        //           showSubRoute: false,
        //           route: "/inventory/reports/502",
        //           subRoutes: [],
        //         },
        //         {
        //           tittle: "Purchase request Details",
        //           hasSubRoute: false,
        //           showSubRoute: false,
        //           route: "/inventory/reports/503",
        //           subRoutes: [],
        //         },
        //         {
        //           tittle: "Purchase Order",
        //           hasSubRoute: false,
        //           showSubRoute: false,
        //           route: "/inventory/reports/504",
        //           subRoutes: [],
        //         },
        //         {
        //           tittle: "Purchase Order Details",
        //           hasSubRoute: false,
        //           showSubRoute: false,
        //           route: "/inventory/reports/505",
        //           subRoutes: [],
        //         },
        //         {
        //           tittle: "Purchase Invoice",
        //           hasSubRoute: false,
        //           showSubRoute: false,
        //           route: "/inventory/reports/506",
        //           subRoutes: [],
        //         },
        //         {
        //           tittle: "Purchase Invoice details",
        //           hasSubRoute: false,
        //           showSubRoute: false,
        //           route: "/inventory/reports/507",
        //           subRoutes: [],
        //         },
        //       ],
        //     },
        //     {
        //       tittle: "Indent Reports",
        //       hasSubRoute: true,
        //       showSubRoute: true,
        //       subRoutes: [
        //         {
        //           tittle: "Indent By City",
        //           hasSubRoute: false,
        //           showSubRoute: false,
        //           route: "/inventory/reports/401",
        //           subRoutes: [],
        //         },
        //         {
        //           tittle: "Indent By Store",
        //           hasSubRoute: false,
        //           showSubRoute: false,
        //           route: "/inventory/reports/402",
        //           subRoutes: [],
        //         },
        //         {
        //           tittle: "All Indents",
        //           hasSubRoute: false,
        //           showSubRoute: false,
        //           route: "/inventory/reports/403",
        //           subRoutes: [],
        //         },
        //         {
        //           tittle: "Local Indents",
        //           hasSubRoute: false,
        //           showSubRoute: false,
        //           route: "/inventory/reports/404",
        //           subRoutes: [],
        //         },
        //       ],
        //     },
        //   ],
        // },
        {
          tittle: "Stock Reports",
          hasSubRoute: true,
          showSubRoute: true,
          subRoutes: [
            {
              tittle: "Low Stock",
              hasSubRoute: false,
              showSubRoute: false,
              route: "/inventory/reports/301",
              subRoutes: [],
            },
            {
              tittle: "Current Stock",
              hasSubRoute: false,
              showSubRoute: false,
              route: "/inventory/reports/302",
              subRoutes: [],
            },
            {
              tittle: "Stock Worth",
              hasSubRoute: false,
              showSubRoute: false,
              route: "/inventory/reports/303",
              subRoutes: [],
            },
            {
              tittle: "Short Supply",
              hasSubRoute: false,
              showSubRoute: false,
              route: "/inventory/reports/304",
              subRoutes: [],
            },
          ],
        },
        {
          tittle: "Inventory Reports",
          hasSubRoute: true,
          showSubRoute: true,
          subRoutes: [
            {
              tittle: "Request By product",
              hasSubRoute: false,
              showSubRoute: false,
              route: "/inventory/reports/501",
              subRoutes: [],
            },
            {
              tittle: "Purchase Request",
              hasSubRoute: false,
              showSubRoute: false,
              route: "/inventory/reports/502",
              subRoutes: [],
            },
            {
              tittle: "Purchase request Details",
              hasSubRoute: false,
              showSubRoute: false,
              route: "/inventory/reports/503",
              subRoutes: [],
            },
            {
              tittle: "Purchase Order",
              hasSubRoute: false,
              showSubRoute: false,
              route: "/inventory/reports/504",
              subRoutes: [],
            },
            {
              tittle: "Purchase Order Details",
              hasSubRoute: false,
              showSubRoute: false,
              route: "/inventory/reports/505",
              subRoutes: [],
            },
            {
              tittle: "Purchase Invoice",
              hasSubRoute: false,
              showSubRoute: false,
              route: "/inventory/reports/506",
              subRoutes: [],
            },
            {
              tittle: "Purchase Invoice details",
              hasSubRoute: false,
              showSubRoute: false,
              route: "/inventory/reports/507",
              subRoutes: [],
            },
          ],
        },
        {
          tittle: "Indent Reports",
          hasSubRoute: true,
          showSubRoute: true,
          subRoutes: [
            {
              tittle: "Indent By City",
              hasSubRoute: false,
              showSubRoute: false,
              route: "/inventory/reports/401",
              subRoutes: [],
            },
            {
              tittle: "Indent By Store",
              hasSubRoute: false,
              showSubRoute: false,
              route: "/inventory/reports/402",
              subRoutes: [],
            },
            {
              tittle: "All Indents",
              hasSubRoute: false,
              showSubRoute: false,
              route: "/inventory/reports/403",
              subRoutes: [],
            },
            {
              tittle: "Local Indents",
              hasSubRoute: false,
              showSubRoute: false,
              route: "/inventory/reports/404",
              subRoutes: [],
            },
          ],
        },
        {
          tittle: "Master",
          hasSubRoute: true,
          icon: "users",
          showSubRoute: false,

          subRoutes: [
            {
              tittle: "Category",
              hasSubRoute: false,
              showSubRoute: true,
              route: "/inventory/category",
              subRoutes: [],
            },
            {
              tittle: "Sub Category",
              hasSubRoute: false,
              showSubRoute: true,
              route: "/inventory/subcategory",
              subRoutes: [],
            },
          ],
        },
        // {
        //   tittle: "Projects",
        //   hasSubRoute: false,
        //   showSubRoute: false,
        //   route: "/low-stocks",
        //   subRoutes: [],
        // },
        // {
        //   tittle: "Sales",
        //   hasSubRoute: false,
        //   showSubRoute: false,
        //   route: "/category-list",
        //   subRoutes: [],
        // },
      ],
      // subRoutes: [
      //   {
      //     tittle: "Stock",
      //     hasSubRoute: true,
      //     showSubRoute: false,
      //     subRoutes: [
      //       {
      //         tittle: "Manage Stock",
      //         hasSubRoute: false,
      //         showSubRoute: false,
      //         route: "/manage-stocks",
      //         subRoutes: [],
      //       },
      //       {
      //         tittle: "Stock Adjustment",
      //         hasSubRoute: false,
      //         showSubRoute: false,
      //         route: "/stock-adjustment",
      //         subRoutes: [],
      //       },
      //       {
      //         tittle: "Stock Transfer",
      //         hasSubRoute: false,
      //         showSubRoute: false,
      //         route: "/stock-transfer",
      //         subRoutes: [],
      //       },
      //     ],
      //   },
      //   {
      //     tittle: "Sales",
      //     hasSubRoute: true,
      //     showSubRoute: false,
      //     route: "/sales-list",
      //     subRoutes: [
      //       {
      //         tittle: "Sales",
      //         hasSubRoute: true,
      //         showSubRoute: true,
      //         subRoutes: [
      //           {
      //             tittle: "Online Orders",
      //             hasSubRoute: false,
      //             showSubRoute: false,
      //             route: "/online-orders",
      //             subRoutes: [],
      //           },
      //           {
      //             tittle: "POS Orders",
      //             hasSubRoute: false,
      //             showSubRoute: false,
      //             route: "/pos-orders",
      //             subRoutes: [],
      //           },
      //         ],
      //       },
      //       {
      //         tittle: "Invoice",
      //         hasSubRoute: false,
      //         showSubRoute: false,
      //         route: "/invoice-settings",
      //         subRoutes: [],
      //       },
      //       {
      //         tittle: "Sales Return",
      //         hasSubRoute: false,
      //         showSubRoute: false,
      //         route: "/sales-returns",
      //         subRoutes: [],
      //       },
      //       {
      //         tittle: "Quotation",
      //         hasSubRoute: false,
      //         showSubRoute: false,
      //         route: "/quotation-list",
      //         subRoutes: [],
      //       },
      //       {
      //         tittle: "POS",
      //         hasSubRoute: true,
      //         showSubRoute: true,
      //         route: "/pos",
      //         subRoutes: [
      //           {
      //             tittle: "POS 1",
      //             hasSubRoute: false,
      //             showSubRoute: false,
      //             route: "/pos",
      //             subRoutes: [],
      //           },
      //           {
      //             tittle: "POS 2",
      //             hasSubRoute: false,
      //             showSubRoute: false,
      //             route: "/pos-2",
      //             subRoutes: [],
      //           },
      //           {
      //             tittle: "POS 3",
      //             hasSubRoute: false,
      //             showSubRoute: false,
      //             route: "/pos-3",
      //             subRoutes: [],
      //           },
      //           {
      //             tittle: "POS 4",
      //             hasSubRoute: false,
      //             showSubRoute: false,
      //             route: "/pos-4",
      //             subRoutes: [],
      //           },
      //           {
      //             tittle: "POS 5",
      //             hasSubRoute: false,
      //             showSubRoute: false,
      //             route: "/pos-5",
      //             subRoutes: [],
      //           },
      //         ],
      //       },
      //     ],
      //   },
      //   {
      //     tittle: "Promo",
      //     hasSubRoute: true,
      //     showSubRoute: false,
      //     activeRoute: "promo",
      //     subRoutes: [
      //       {
      //         tittle: "Coupons",
      //         hasSubRoute: false,
      //         showSubRoute: false,
      //         route: "/coupons",
      //         subRoutes: [],
      //       },
      //       {
      //         tittle: "Gift Cards",
      //         hasSubRoute: false,
      //         showSubRoute: false,
      //         route: "/gift-cards",
      //         subRoutes: [],
      //       },
      //       {
      //         tittle: "Discount",
      //         hasSubRoute: true,
      //         showSubRoute: true,
      //         subRoutes: [
      //           {
      //             tittle: "Discount Plan",
      //             hasSubRoute: false,
      //             showSubRoute: false,
      //             route: "/discount-plan",
      //             subRoutes: [],
      //           },
      //           {
      //             tittle: "Discount",
      //             hasSubRoute: false,
      //             showSubRoute: false,
      //             route: "/discount",
      //             subRoutes: [],
      //           },
      //         ],
      //       },
      //     ],
      //   },
      //   {
      //     tittle: "Purchases",
      //     hasSubRoute: true,
      //     showSubRoute: false,
      //     activeRoute: "users",
      //     subRoutes: [
      //       {
      //         tittle: "Purchases",
      //         hasSubRoute: false,
      //         showSubRoute: false,
      //         route: "/purchase-list",
      //         subRoutes: [],
      //       },
      //       {
      //         tittle: "Purchase Order",
      //         hasSubRoute: false,
      //         showSubRoute: false,
      //         route: "/purchase-order-report",
      //         subRoutes: [],
      //       },
      //       {
      //         tittle: "Purchase Return",
      //         hasSubRoute: false,
      //         showSubRoute: false,
      //         route: "/purchase-returns",
      //         subRoutes: [],
      //       },
      //       {
      //         tittle: "Expenses",
      //         hasSubRoute: true,
      //         showSubRoute: true,
      //         subRoutes: [
      //           {
      //             tittle: "Expenses",
      //             hasSubRoute: false,
      //             showSubRoute: false,
      //             route: "/expense-list",
      //             subRoutes: [],
      //           },
      //           {
      //             tittle: "Expense Category",
      //             hasSubRoute: false,
      //             showSubRoute: false,
      //             route: "/expense-category",
      //             subRoutes: [],
      //           },
      //         ],
      //       },
      //     ],
      //   },
      //   {
      //     tittle: "Expenses",
      //     hasSubRoute: true,
      //     showSubRoute: true,
      //     //   route: routes.stockTransfer,
      //     subRoutes: [
      //       {
      //         tittle: "Expenses",
      //         route: "/expense-list",
      //       },
      //       {
      //         tittle: "Expense Category",
      //         route: "/expense-category",
      //       },
      //     ],
      //   },
      //   {
      //     tittle: "Income",
      //     hasSubRoute: true,
      //     showSubRoute: false,
      //     route: "/purchase-returns",
      //     subRoutes: [
      //       {
      //         tittle: "Income",
      //         hasSubRoute: false,
      //         showSubRoute: false,
      //         route: "/income",
      //         subRoutes: [],
      //       },
      //       {
      //         tittle: "Income Category",
      //         hasSubRoute: false,
      //         showSubRoute: false,
      //         route: "/income-category",
      //         subRoutes: [],
      //       },
      //     ],
      //   },
      //   {
      //     tittle: "Bank Accounts",
      //     hasSubRoute: false,
      //     showSubRoute: false,
      //     route: "/account-list",
      //     subRoutes: [],
      //   },
      //   {
      //     tittle: "Money Transfer",
      //     hasSubRoute: false,
      //     showSubRoute: false,
      //     route: "/money-transfer",
      //     subRoutes: [],
      //   },
      //   {
      //     tittle: "Balance Sheet",
      //     hasSubRoute: false,
      //     showSubRoute: false,
      //     route: "/balance-sheet",
      //     subRoutes: [],
      //   },
      //   {
      //     tittle: "Trial Balance",
      //     hasSubRoute: false,
      //     showSubRoute: false,
      //     route: "/trial-balance",
      //     subRoutes: [],
      //   },
      //   {
      //     tittle: "Cash Flow",
      //     hasSubRoute: false,
      //     showSubRoute: false,
      //     route: "/cash-flow",
      //     subRoutes: [],
      //   },
      //   {
      //     tittle: "Account Statement",
      //     hasSubRoute: false,
      //     showSubRoute: false,
      //     route: "/account-statement",
      //     subRoutes: [],
      //   },
      // ],
    },
    {
      tittle: "Production",
      hasSubRoute: true,
      icon: "package",
      showSubRoute: false,
      activeRoute: "/bom/dashboard",
      route: "/bom/dashboard",
      subRoutes: [
        {
          tittle: "Bill Of Material",
          hasSubRoute: false,
          icon: "users",
          showSubRoute: false,
          route: "/bom/bomlist",
        },
        {
          tittle: "Item",
          hasSubRoute: false,
          icon: "users",
          showSubRoute: false,
          route: "/bom/itemslist",
        },
        {
          tittle: "Job Card",
          hasSubRoute: false,
          icon: "users",
          showSubRoute: false,
          route: "/bom/jobcardlist",
        },
        {
          tittle: "Package",
          hasSubRoute: false,
          icon: "users",
          showSubRoute: false,
          route: "/bom/packages",
        },
        {
          tittle: "Check Availability",
          hasSubRoute: false,
          icon: "users",
          showSubRoute: false,
          route: "/bom/checkavailability",
        },
      ],
    },
    {
      tittle: "Asset Mngmt",
      hasSubRoute: true,
      icon: "folder-open",
      showSubRoute: false,
      activeRoute: "/assetmgt/dashboard",
      route: "/assetmgt/dashboard",
      subRoutes: [
        {
          tittle: "Assets",
          hasSubRoute: true,
          icon: "user",
          showSubRoute: true,
          subRoutes: [
            // {
            //   tittle: "HR",
            //   hasSubRoute: true,
            //   icon: "layout-grid",
            //   showSubRoute: false,
            //   subRoutes: [
            //     {
            //       tittle: "Rollcall",
            //       hasSubRoute: false,
            //       showSubRoute: false,
            //       route: '/rollcall/dashboard',
            //     },
            //     {
            //       tittle: "Payroll",
            //       hasSubRoute: false,
            //       showSubRoute: false,
            //       route: '/payroll/dashboard',
            //     },
            //     {
            //       tittle: "Applicant Tracking",
            //       hasSubRoute: false,
            //       showSubRoute: false,
            //       base: "application",
            //       route: 'applicantTracking/dashboard',
            //     },
            //   ],
            // },
            {
              tittle: "Assets",
              hasSubRoute: false,
              showSubRoute: false,
              route: "/assetmgt/assets",
              subRoutes: [],
            },
            {
              tittle: "Using Assets",
              hasSubRoute: false,
              showSubRoute: false,
              route: "/assetmgt/using",
            },
            {
              tittle: "Unused Assets",
              hasSubRoute: false,
              showSubRoute: false,
              route: "/assetmgt/unused",
            },
            {
              tittle: "Broken Assets",
              hasSubRoute: false,
              showSubRoute: false,
              route: "/assetmgt/broken",
            },
            {
              tittle: "Lost Assets",
              hasSubRoute: false,
              showSubRoute: false,
              route: "/assetmgt/lost",
            },
            {
              tittle: "Assets Details",
              hasSubRoute: false,
              showSubRoute: false,
              route: "assetmgt/assetdetails",
            },
          ],
        },
        // {
        //   tittle: "Assets",
        //   hasSubRoute: false,
        //   icon: "users",
        //   showSubRoute: false,
        //   route: "/assetmgt/assets",
        // },
        {
          tittle: "Liquidation",
          hasSubRoute: false,
          icon: "users",
          showSubRoute: false,
          route: "/assetmgt/liquidation",
        },
        {
          tittle: "Warranty Repair",
          hasSubRoute: false,
          icon: "users",
          showSubRoute: false,
          route: "/assetmgt/warrantyrepair",
        },
        {
          tittle: "Suppliers",
          hasSubRoute: false,
          icon: "users",
          showSubRoute: false,
          route: "/assetmgt/suppliers",
        },
      ],
    },
    {
      tittle: "Project Mngmt",
      hasSubRoute: true,
      icon: "chart-pie",
      showSubRoute: false,
      activeRoute: "/projectmgt/dashboard",
      route: "/projectmgt/dashboard",
      subRoutes: [
        {
          tittle: "Projects",
          hasSubRoute: false,
          icon: "users",
          showSubRoute: false,
          route: "/projectmgt/dashboard",
        },
        {
          tittle: "Tasks",
          hasSubRoute: false,
          icon: "users",
          showSubRoute: false,
          route: "/crm/tasks",
        },
        {
          tittle: "Expenses",
          hasSubRoute: false,
          icon: "users",
          showSubRoute: false,
          route: "/expense-list",
        },
        {
          tittle: "Time Sheet",
          hasSubRoute: false,
          icon: "users",
          showSubRoute: false,
          route: "/ui-timeline",
        },
      ],
    },
    {
      tittle: "Admin",
      hasSubRoute: true,
      icon: "user-circle",
      showSubRoute: false,
      subRoutes: [
        {
          tittle: "Holidays",
          route: "/admin/holidays",
          hasSubRoute: false,
          showSubRoute: false,
        },
        {
          tittle: "Products",
          route: "/products",
          hasSubRoute: false,
          showSubRoute: false,
        },
      ],
      //   {
      //     tittle: "Authentication",
      //     hasSubRoute: true,
      //     showSubRoute: false,
      //     //   route: routes.purchaseReport,
      //     subRoutes: [
      //       {
      //         tittle: "Login",
      //         hasSubRoute: true,
      //         showSubRoute: false,
      //         route: "/signin",
      //         subRoutes: [
      //           {
      //             tittle: "Cover",
      //             route: "/signin",
      //             hasSubRoute: false,
      //             showSubRoute: false,
      //           },
      //           {
      //             tittle: "Illustration",
      //             route: "/signin-2",
      //             hasSubRoute: false,
      //             showSubRoute: false,
      //           },
      //           {
      //             tittle: "Basic",
      //             route: "/signin-3",
      //             hasSubRoute: false,
      //             showSubRoute: false,
      //           },
      //         ],
      //       },
      //       {
      //         tittle: "Register",
      //         hasSubRoute: true,
      //         showSubRoute: false,
      //         route: "/register",
      //         subRoutes: [
      //           {
      //             tittle: "Cover",
      //             route: "/signin",
      //             hasSubRoute: false,
      //             showSubRoute: false,
      //           },
      //           {
      //             tittle: "Illustration",
      //             route: "/signin-2",
      //             hasSubRoute: false,
      //             showSubRoute: false,
      //           },
      //           {
      //             tittle: "Basic",
      //             route: "/signin-3",
      //             hasSubRoute: false,
      //             showSubRoute: false,
      //           },
      //         ],
      //       },
      //       {
      //         tittle: "Forgot Password",
      //         hasSubRoute: true,
      //         showSubRoute: false,
      //         route: "/forgot-password",
      //         subRoutes: [
      //           {
      //             tittle: "Cover",
      //             route: "/forgot-password",
      //             hasSubRoute: false,
      //             showSubRoute: false,
      //           },
      //           {
      //             tittle: "Illustration",
      //             route: "/signin-2",
      //             hasSubRoute: false,
      //             showSubRoute: false,
      //           },
      //           {
      //             tittle: "Basic",
      //             route: "/signin-3",
      //             hasSubRoute: false,
      //             showSubRoute: false,
      //           },
      //         ],
      //       },
      //       {
      //         tittle: "Reset Password",
      //         hasSubRoute: true,
      //         showSubRoute: false,
      //         route: "/reset-password",
      //         subRoutes: [
      //           {
      //             tittle: "Cover",
      //             route: "/signin",
      //             hasSubRoute: false,
      //             showSubRoute: false,
      //           },
      //           {
      //             tittle: "Illustration",
      //             route: "/signin-2",
      //             hasSubRoute: false,
      //             showSubRoute: false,
      //           },
      //           {
      //             tittle: "Basic",
      //             route: "/signin-3",
      //             hasSubRoute: false,
      //             showSubRoute: false,
      //           },
      //         ],
      //       },
      //       {
      //         tittle: "Email Verification",
      //         hasSubRoute: true,
      //         showSubRoute: false,
      //         route: "/email-verification",
      //         subRoutes: [
      //           {
      //             tittle: "Cover",
      //             route: "/signin",
      //             hasSubRoute: false,
      //             showSubRoute: false,
      //           },
      //           {
      //             tittle: "Illustration",
      //             route: "/signin-2",
      //             hasSubRoute: false,
      //             showSubRoute: false,
      //           },
      //           {
      //             tittle: "Basic",
      //             route: "/signin-3",
      //             hasSubRoute: false,
      //             showSubRoute: false,
      //           },
      //         ],
      //       },
      //       {
      //         tittle: "2 Step Verification",
      //         hasSubRoute: true,
      //         showSubRoute: false,
      //         route: "/two-step-verification",
      //         subRoutes: [
      //           {
      //             tittle: "Cover",
      //             route: "/signin",
      //             hasSubRoute: false,
      //             showSubRoute: false,
      //           },
      //           {
      //             tittle: "Illustration",
      //             route: "/signin-2",
      //             hasSubRoute: false,
      //             showSubRoute: false,
      //           },
      //           {
      //             tittle: "Basic",
      //             route: "/signin-3",
      //             hasSubRoute: false,
      //             showSubRoute: false,
      //           },
      //         ],
      //       },
      //     ],
      //   },
      //   {
      //     tittle: "Error",
      //     hasSubRoute: true,
      //     showSubRoute: false,
      //     //   route: routes.purchaseReport,
      //     subRoutes: [
      //       {
      //         tittle: "404 Error",
      //         hasSubRoute: true,
      //         showSubRoute: false,
      //         route: "/error-404",
      //         subRoutes: [],
      //       },
      //       {
      //         tittle: "500 Error",
      //         hasSubRoute: true,
      //         showSubRoute: false,
      //         route: "/error-500",
      //         subRoutes: [],
      //       },
      //     ],
      //   },
      //   {
      //     tittle: "Blank page",
      //     hasSubRoute: false,
      //     showSubRoute: false,
      //     route: "/blank-page",
      //     subRoutes: [],
      //   },
      //   {
      //     tittle: "Pricing",
      //     hasSubRoute: false,
      //     showSubRoute: false,
      //     route: "/pricing",
      //     subRoutes: [],
      //   },
      //   {
      //     tittle: "Comming Soon",
      //     hasSubRoute: false,
      //     showSubRoute: false,
      //     route: "/coming-soon",
      //     subRoutes: [],
      //   },
      //   {
      //     tittle: "Under Maintenance",
      //     hasSubRoute: false,
      //     showSubRoute: false,
      //     route: "/under-maintenance",
      //     subRoutes: [],
      //   },
      //   {
      //     tittle: "Content",
      //     hasSubRoute: true,
      //     showSubRoute: false,
      //     //   route: routes.purchaseReport,
      //     subRoutes: [
      //       {
      //         tittle: "Pages",
      //         hasSubRoute: true,
      //         showSubRoute: true,
      //         // route:"/employees-grid",
      //         subRoutes: [
      //           {
      //             tittle: "Pages",
      //             hasSubRoute: true,
      //             showSubRoute: true,
      //             route: "/pages",
      //             subRoutes: [],
      //           },
      //         ],
      //       },
      //       {
      //         tittle: "Blog",
      //         hasSubRoute: true,
      //         showSubRoute: true,
      //         subRoutes: [
      //           {
      //             tittle: "All Blog",
      //             hasSubRoute: true,
      //             showSubRoute: true,
      //             route: "/all-blog",
      //             subRoutes: [],
      //           },
      //           {
      //             tittle: "Blog Tags",
      //             hasSubRoute: true,
      //             showSubRoute: true,
      //             route: "/blog-tag",
      //             subRoutes: [],
      //           },
      //           {
      //             tittle: "Categories",
      //             hasSubRoute: true,
      //             showSubRoute: true,
      //             route: "/blog-categories",
      //             subRoutes: [],
      //           },
      //           {
      //             tittle: "Blog Comments",
      //             hasSubRoute: true,
      //             showSubRoute: true,
      //             route: "/blog-comments",
      //             subRoutes: [],
      //           },
      //         ],
      //       },
      //       {
      //         tittle: "Location",
      //         hasSubRoute: true,
      //         showSubRoute: true,
      //         subRoutes: [
      //           {
      //             tittle: "Countries",
      //             hasSubRoute: true,
      //             showSubRoute: true,
      //             route: "/countries",
      //             subRoutes: [],
      //           },
      //           {
      //             tittle: "States",
      //             hasSubRoute: true,
      //             showSubRoute: true,
      //             route: "/states",
      //             subRoutes: [],
      //           },
      //           {
      //             tittle: "Cities",
      //             hasSubRoute: true,
      //             showSubRoute: true,
      //             route: "/cities",
      //             subRoutes: [],
      //           },
      //           {
      //             tittle: "Testimonials",
      //             hasSubRoute: true,
      //             showSubRoute: true,
      //             route: "/testimonials",
      //             subRoutes: [],
      //           },
      //         ],
      //       },
      //       {
      //         tittle: "FAQ",
      //         hasSubRoute: false,
      //         showSubRoute: false,
      //         route: "/faq",
      //         subRoutes: [],
      //       },
      //     ],
      //   },
      //   {
      //     tittle: "Employees",
      //     hasSubRoute: true,
      //     showSubRoute: false,
      //     //   route: routes.purchaseReport,
      //     subRoutes: [
      //       {
      //         tittle: "Employees",
      //         hasSubRoute: true,
      //         showSubRoute: false,
      //         route: "/employees-grid",
      //         subRoutes: [],
      //       },
      //       {
      //         tittle: "Designations",
      //         hasSubRoute: true,
      //         showSubRoute: false,
      //         route: "/designation",
      //         subRoutes: [],
      //       },
      //       {
      //         tittle: "Departments",
      //         hasSubRoute: true,
      //         showSubRoute: false,
      //         route: "/department-grid",
      //         subRoutes: [],
      //       },
      //       {
      //         tittle: "Shifts",
      //         hasSubRoute: true,
      //         showSubRoute: false,
      //         route: "/shift",
      //         subRoutes: [],
      //       },
      //     ],
      //   },
      //   {
      //     tittle: "Attendance",
      //     hasSubRoute: true,
      //     showSubRoute: false,
      //     //   route: routes.purchaseReport,
      //     subRoutes: [
      //       {
      //         tittle: "Employee Attendance",
      //         hasSubRoute: true,
      //         showSubRoute: false,
      //         route: "/attendance-employee",
      //         subRoutes: [],
      //       },
      //       {
      //         tittle: "Admin Attendance",
      //         hasSubRoute: true,
      //         showSubRoute: false,
      //         route: "/attendance-admin",
      //         subRoutes: [],
      //       },
      //     ],
      //   },
      //   {
      //     tittle: "Leave & Holidays",
      //     hasSubRoute: true,
      //     showSubRoute: false,
      //     //   route: routes.purchaseReport,
      //     subRoutes: [
      //       {
      //         tittle: "Admin Leaves",
      //         hasSubRoute: true,
      //         showSubRoute: false,
      //         route: "/leaves-admin",
      //         subRoutes: [],
      //       },
      //       {
      //         tittle: "Employee Leaves",
      //         hasSubRoute: true,
      //         showSubRoute: false,
      //         route: "/leaves-employee",
      //         subRoutes: [],
      //       },
      //       {
      //         tittle: "Leave Types",
      //         hasSubRoute: true,
      //         showSubRoute: false,
      //         route: "/leave-types",
      //         subRoutes: [],
      //       },
      //       {
      //         tittle: "Holidays",
      //         hasSubRoute: true,
      //         showSubRoute: false,
      //         route: "/holidays",
      //         subRoutes: [],
      //       },
      //       {
      //         tittle: "Payroll",
      //         hasSubRoute: true,
      //         showSubRoute: true,
      //         route: "/employee-salary",
      //         subRoutes: [
      //           {
      //             tittle: "Employee Salary",
      //             hasSubRoute: false,
      //             showSubRoute: false,
      //             route: "/employee-salary",
      //             subRoutes: [],
      //           },
      //           {
      //             tittle: "Payslip",
      //             hasSubRoute: false,
      //             showSubRoute: false,
      //             route: "/payslip",
      //             subRoutes: [],
      //           },
      //         ],
      //       },
      //     ],
      //   },
      // ],
    },
    // {
    //   tittle: "Misc",
    //   hasSubRoute: false,
    //   icon: "chart-bar",
    //   showSubRoute: false,
    //   activeRoute: "users",
    //   // subRoutes: [
    //   //   {
    //   //     tittle: "Sales Report",
    //   //     hasSubRoute: true,
    //   //     showSubRoute: true,
    //   //     subRoutes: [
    //   //       {
    //   //         tittle: "Sales Report",
    //   //         hasSubRoute: false,
    //   //         showSubRoute: false,
    //   //         route: "/sales-report",
    //   //       },
    //   //       {
    //   //         tittle: "Best Seller",
    //   //         hasSubRoute: false,
    //   //         showSubRoute: false,
    //   //         route: "/best-seller",
    //   //       },
    //   //     ],
    //   //   },
    //   //   {
    //   //     tittle: "Purchase Report",
    //   //     hasSubRoute: false,
    //   //     showSubRoute: false,
    //   //     route: "/purchase-report",
    //   //     subRoutes: [],
    //   //   },
    //   //   {
    //   //     tittle: "Inventory Report",
    //   //     hasSubRoute: false,
    //   //     showSubRoute: false,
    //   //     route: "/inventory-report",
    //   //     subRoutes: [
    //   //       {
    //   //         tittle: "Inventory Report",
    //   //         hasSubRoute: false,
    //   //         showSubRoute: false,
    //   //         route: "/inventory-report",
    //   //         subRoutes: [],
    //   //       },
    //   //       {
    //   //         tittle: "Stock History",
    //   //         hasSubRoute: false,
    //   //         showSubRoute: false,
    //   //         route: "/stock-history",
    //   //         subRoutes: [],
    //   //       },
    //   //       {
    //   //         tittle: "Sold Stock",
    //   //         hasSubRoute: false,
    //   //         showSubRoute: false,
    //   //         route: "/sold-stock",
    //   //         subRoutes: [],
    //   //       },
    //   //     ],
    //   //   },
    //   //   {
    //   //     tittle: "Invoice Report",
    //   //     hasSubRoute: false,
    //   //     showSubRoute: false,
    //   //     route: "/invoice-report",
    //   //     subRoutes: [],
    //   //   },
    //   //   {
    //   //     tittle: "Supplier Report",
    //   //     hasSubRoute: true,
    //   //     showSubRoute: true,
    //   //     subRoutes: [
    //   //       {
    //   //         tittle: "Supplier Report",
    //   //         hasSubRoute: false,
    //   //         showSubRoute: false,
    //   //         route: "/supplier-report",
    //   //         subRoutes: [],
    //   //       },
    //   //       {
    //   //         tittle: "Supplier Due Report",
    //   //         hasSubRoute: false,
    //   //         showSubRoute: false,
    //   //         route: "/supplier-due-report",
    //   //         subRoutes: [],
    //   //       },
    //   //     ],
    //   //   },

    //   //   {
    //   //     tittle: "Customer Report",
    //   //     hasSubRoute: false,
    //   //     showSubRoute: false,
    //   //     subRoutes: [
    //   //       {
    //   //         tittle: "Customer Report",
    //   //         hasSubRoute: false,
    //   //         showSubRoute: false,
    //   //         route: "/customer-report",
    //   //         subRoutes: [],
    //   //       },
    //   //       {
    //   //         tittle: "Customer Due Report",
    //   //         hasSubRoute: false,
    //   //         showSubRoute: false,
    //   //         route: "/customer-due-report",
    //   //         subRoutes: [],
    //   //       },
    //   //     ],
    //   //   },
    //   //   {
    //   //     tittle: "Product Report",
    //   //     hasSubRoute: false,
    //   //     showSubRoute: false,
    //   //     subRoutes: [
    //   //       {
    //   //         tittle: "Product Report",
    //   //         hasSubRoute: false,
    //   //         showSubRoute: false,
    //   //         route: "/product-report",
    //   //         subRoutes: [],
    //   //       },
    //   //       {
    //   //         tittle: "Product Expiry Report",
    //   //         hasSubRoute: false,
    //   //         showSubRoute: false,
    //   //         route: "/product-expiry-report",
    //   //         subRoutes: [],
    //   //       },
    //   //       {
    //   //         tittle: "Product Quantity Alert",
    //   //         hasSubRoute: false,
    //   //         showSubRoute: false,
    //   //         route: "/product-quantity-alert",
    //   //         subRoutes: [],
    //   //       },
    //   //     ],
    //   //   },
    //   //   {
    //   //     tittle: "Expense Report",
    //   //     hasSubRoute: false,
    //   //     showSubRoute: false,
    //   //     route: "/expense-report",
    //   //     subRoutes: [],
    //   //   },
    //   //   {
    //   //     tittle: "Income Report",
    //   //     hasSubRoute: false,
    //   //     showSubRoute: false,
    //   //     route: "/income-report",
    //   //     subRoutes: [],
    //   //   },
    //   //   {
    //   //     tittle: "Tax Report",
    //   //     hasSubRoute: false,
    //   //     showSubRoute: false,
    //   //     route: "/tax-report",
    //   //     subRoutes: [],
    //   //   },
    //   //   {
    //   //     tittle: "Profit & Loss",
    //   //     hasSubRoute: false,
    //   //     showSubRoute: false,
    //   //     route: "/profit-and-loss",
    //   //     subRoutes: [],
    //   //   },
    //   //   {
    //   //     tittle: "Annual Report",
    //   //     hasSubRoute: false,
    //   //     showSubRoute: false,
    //   //     route: "/annual-report",
    //   //     subRoutes: [],
    //   //   },
    //   // ],
    // },
    // {
    //   tittle: "Gallery",
    //   hasSubRoute: false,
    //   icon: "settings",
    //   showSubRoute: false,
    //   activeRoute: "users",
    //   // subRoutes: [
    //   //   {
    //   //     tittle: "General Settings",
    //   //     hasSubRoute: true,
    //   //     showSubRoute: false,
    //   //     //   route: routes.users,
    //   //     subRoutes: [
    //   //       {
    //   //         tittle: "Profile",
    //   //         route: "/profile",
    //   //         hasSubRoute: false,
    //   //         showSubRoute: false,
    //   //       },
    //   //       {
    //   //         tittle: "Security",
    //   //         route: "/security-settings",
    //   //         hasSubRoute: false,
    //   //         showSubRoute: false,
    //   //       },
    //   //       {
    //   //         tittle: "Notifications",
    //   //         route: "/notification",
    //   //         hasSubRoute: false,
    //   //         showSubRoute: false,
    //   //       },
    //   //       {
    //   //         tittle: "Connected Apps",
    //   //         route: "/connected-apps",
    //   //         hasSubRoute: false,
    //   //         showSubRoute: false,
    //   //       },
    //   //     ],
    //   //   },
    //   //   {
    //   //     tittle: "Website Settings",
    //   //     hasSubRoute: true,
    //   //     showSubRoute: false,
    //   //     subRoutes: [
    //   //       {
    //   //         tittle: "System Settings",
    //   //         route: "/system-settings",
    //   //         hasSubRoute: false,
    //   //         showSubRoute: false,
    //   //       },
    //   //       {
    //   //         tittle: "Company Settings",
    //   //         route: "/company-settings",
    //   //         hasSubRoute: false,
    //   //         showSubRoute: false,
    //   //       },
    //   //       {
    //   //         tittle: "Localization",
    //   //         route: "/localization-settings",
    //   //         hasSubRoute: false,
    //   //         showSubRoute: false,
    //   //       },
    //   //       {
    //   //         tittle: "Prefixes",
    //   //         route: "/prefixes",
    //   //         hasSubRoute: false,
    //   //         showSubRoute: false,
    //   //       },
    //   //       {
    //   //         tittle: "Preference",
    //   //         route: "/preference",
    //   //         hasSubRoute: false,
    //   //         showSubRoute: false,
    //   //       },
    //   //       {
    //   //         tittle: "Appearance",
    //   //         route: "/appearance",
    //   //         hasSubRoute: false,
    //   //         showSubRoute: false,
    //   //       },
    //   //       {
    //   //         tittle: "Social Authentication",
    //   //         route: "/social-authentication",
    //   //         hasSubRoute: false,
    //   //         showSubRoute: false,
    //   //       },
    //   //       {
    //   //         tittle: "Language",
    //   //         route: "/language-settings",
    //   //         hasSubRoute: false,
    //   //         showSubRoute: false,
    //   //       },
    //   //     ],
    //   //   },

    //   //   {
    //   //     tittle: "App Settings",
    //   //     hasSubRoute: true,
    //   //     showSubRoute: false,
    //   //     activeRoute: "users",
    //   //     subRoutes: [
    //   //       {
    //   //         tittle: "Invoice",
    //   //         hasSubRoute: true,
    //   //         showSubRoute: true,
    //   //         subRoutes: [
    //   //           {
    //   //             tittle: "Invoice Settings",
    //   //             route: "/invoice-settings",
    //   //             hasSubRoute: true,
    //   //             showSubRoute: true,
    //   //             subRoutes: [],
    //   //           },
    //   //           {
    //   //             tittle: "Invoice Template",
    //   //             route: "/invoice-template",
    //   //             hasSubRoute: true,
    //   //             showSubRoute: true,
    //   //             subRoutes: [],
    //   //           },
    //   //         ],
    //   //       },
    //   //       {
    //   //         tittle: "Printer",
    //   //         route: "/printer-settings",
    //   //         hasSubRoute: false,
    //   //         showSubRoute: false,
    //   //       },
    //   //       {
    //   //         tittle: "POS",
    //   //         route: "/pos-settings",
    //   //         hasSubRoute: false,
    //   //         showSubRoute: false,
    //   //       },
    //   //       {
    //   //         tittle: "Custom Fields",
    //   //         route: "/custom-fields",
    //   //         hasSubRoute: false,
    //   //         showSubRoute: false,
    //   //       },
    //   //     ],
    //   //   },
    //   //   {
    //   //     tittle: "System Settings",
    //   //     hasSubRoute: true,
    //   //     showSubRoute: false,
    //   //     activeRoute: "users",
    //   //     subRoutes: [
    //   //       {
    //   //         tittle: "Email",
    //   //         hasSubRoute: true,
    //   //         showSubRoute: true,
    //   //         subRoutes: [
    //   //           {
    //   //             tittle: "Email Settings",
    //   //             route: "/email-settings",
    //   //             hasSubRoute: false,
    //   //             showSubRoute: false,
    //   //           },
    //   //           {
    //   //             tittle: "Email Template",
    //   //             route: "/email-template",
    //   //             hasSubRoute: false,
    //   //             showSubRoute: false,
    //   //           },
    //   //         ],
    //   //       },
    //   //       {
    //   //         tittle: "SMS",
    //   //         hasSubRoute: true,
    //   //         showSubRoute: true,
    //   //         subRoutes: [
    //   //           {
    //   //             tittle: "SMS Settings",
    //   //             route: "/sms-settings",
    //   //             hasSubRoute: false,
    //   //             showSubRoute: false,
    //   //           },
    //   //           {
    //   //             tittle: "SMS Template",
    //   //             route: "/sms-template",
    //   //             hasSubRoute: false,
    //   //             showSubRoute: false,
    //   //           },
    //   //         ],
    //   //       },
    //   //       {
    //   //         tittle: "OTP",
    //   //         route: "/otp-settings",
    //   //         hasSubRoute: false,
    //   //         showSubRoute: false,
    //   //       },
    //   //       {
    //   //         tittle: "GDPR Cookies",
    //   //         route: "/gdpr-settings",
    //   //         hasSubRoute: false,
    //   //         showSubRoute: false,
    //   //       },
    //   //     ],
    //   //   },
    //   //   {
    //   //     tittle: "Financial Settings",
    //   //     hasSubRoute: true,
    //   //     showSubRoute: false,
    //   //     activeRoute: "users",
    //   //     subRoutes: [
    //   //       {
    //   //         tittle: "Payment Gateway",
    //   //         route: "/payment-gateway-settings",
    //   //         hasSubRoute: false,
    //   //         showSubRoute: false,
    //   //       },
    //   //       {
    //   //         tittle: "Bank Accounts",
    //   //         route: "/bank-settings-grid",
    //   //         hasSubRoute: false,
    //   //         showSubRoute: false,
    //   //       },
    //   //       {
    //   //         tittle: "Tax Rates",
    //   //         route: "/tax-rates",
    //   //         hasSubRoute: false,
    //   //         showSubRoute: false,
    //   //       },
    //   //       {
    //   //         tittle: "Currencies",
    //   //         route: "/currency-settings",
    //   //         hasSubRoute: false,
    //   //         showSubRoute: false,
    //   //       },
    //   //     ],
    //   //   },
    //   //   {
    //   //     tittle: "Other Settings",
    //   //     hasSubRoute: true,
    //   //     showSubRoute: false,
    //   //     activeRoute: "users",
    //   //     subRoutes: [
    //   //       {
    //   //         tittle: "Storage",
    //   //         route: "/storage-settings",
    //   //         hasSubRoute: false,
    //   //         showSubRoute: false,
    //   //       },
    //   //       {
    //   //         tittle: "Ban IP Address",
    //   //         route: "/ban-ip-address",
    //   //         hasSubRoute: false,
    //   //         showSubRoute: false,
    //   //       },
    //   //     ],
    //   //   },
    //   //   {
    //   //     tittle: "Logout",
    //   //     hasSubRoute: false,
    //   //     showSubRoute: false,
    //   //     route: "/signin",
    //   //   },
    //   // ],
    // },
    // {
    //   tittle: "Settings",
    //   hasSubRoute: false,
    //   icon: "circle-plus",
    //   showSubRoute: false,
    //   activeRoute: "More",
    //   // subRoutes: [
    //   //   {
    //   //     tittle: "People",
    //   //     hasSubRoute: true,
    //   //     showSubRoute: false,
    //   //     //   route: routes.users,
    //   //     subRoutes: [
    //   //       {
    //   //         tittle: "Customers",
    //   //         hasSubRoute: false,
    //   //         showSubRoute: false,
    //   //         route: "/customers",
    //   //         subRoutes: [],
    //   //       },
    //   //       {
    //   //         tittle: "Billers",
    //   //         hasSubRoute: false,
    //   //         showSubRoute: false,
    //   //         route: "/billers",
    //   //         subRoutes: [],
    //   //       },
    //   //       {
    //   //         tittle: "Suppliers",
    //   //         hasSubRoute: false,
    //   //         showSubRoute: false,
    //   //         route: "/suppliers",
    //   //         subRoutes: [],
    //   //       },
    //   //       {
    //   //         tittle: "Stores",
    //   //         hasSubRoute: false,
    //   //         showSubRoute: false,
    //   //         route: "/store-list",
    //   //         subRoutes: [],
    //   //       },
    //   //       {
    //   //         tittle: "Warehouses",
    //   //         hasSubRoute: false,
    //   //         showSubRoute: false,
    //   //         route: "/warehouse",
    //   //         subRoutes: [],
    //   //       },
    //   //     ],
    //   //   },
    //   //   {
    //   //     tittle: "User Management",
    //   //     hasSubRoute: true,
    //   //     showSubRoute: false,
    //   //     //   route: routes.users,
    //   //     subRoutes: [
    //   //       {
    //   //         tittle: "Users",
    //   //         hasSubRoute: false,
    //   //         showSubRoute: false,
    //   //         route: "/users",
    //   //         subRoutes: [],
    //   //       },
    //   //       {
    //   //         tittle: "Roles & Permissions",
    //   //         hasSubRoute: false,
    //   //         showSubRoute: false,
    //   //         route: "/roles-permissions",
    //   //         subRoutes: [],
    //   //       },
    //   //       {
    //   //         tittle: "Delete Account Request",
    //   //         hasSubRoute: false,
    //   //         showSubRoute: false,
    //   //         route: "/delete-account",
    //   //         subRoutes: [],
    //   //       },
    //   //     ],
    //   //   },
    //   //   {
    //   //     tittle: "Documentation",
    //   //     hasSubRoute: false,
    //   //     showSubRoute: false,
    //   //     activeRoute: "users",
    //   //   },
    //   //   {
    //   //     tittle: "Changelog v2.0.7",
    //   //     hasSubRoute: false,
    //   //     showSubRoute: false,
    //   //     activeRoute: "users",
    //   //   },
    //   // ],
    // },
  ],

  hr: [
    {
      tittle: "Modules",
      hasSubRoute: true,
      icon: "layout-grid",
      showSubRoute: true,
      subRoutes: [
        // {
        //   tittle: "Rollcall",
        //   hasSubRoute: false,
        //   showSubRoute: false,
        //   route: "/rollcall/dashboard",
        // },
        // {
        //   tittle: "Payroll",
        //   hasSubRoute: false,
        //   showSubRoute: false,
        //   route: "/payroll/dashboard",
        // },
        // {
        //   tittle: "Applicant Tracking",
        //   hasSubRoute: false,
        //   showSubRoute: false,
        //   base: "application",
        //   route: "applicantTracking/dashboard",
        // },
        {
          tittle: "HR",
          hasSubRoute: false,
          icon: "layout-grid",
          showSubRoute: false,
          route: "/hr",
          // subRoutes: [
          //   {
          //     tittle: "Rollcall",
          //     hasSubRoute: false,
          //     showSubRoute: false,
          //     route: "/rollcall/dashboard",
          //   },
          //   {
          //     tittle: "Payroll",
          //     hasSubRoute: false,
          //     showSubRoute: false,
          //     route: "/payroll/dashboard",
          //   },
          //   {
          //     tittle: "Applicant Tracking",
          //     hasSubRoute: false,
          //     showSubRoute: false,
          //     base: "application",
          //     route: "applicantTracking/dashboard",
          //   },
          // ],
        },
        {
          tittle: "Inventory",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/inventory/dashboard",
          subRoutes: [],
        },
        {
          tittle: "Asset Management",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/assetmgt/dashboard",
        },
        {
          tittle: "Project Management",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/projectmgt/dashboard",
        },
        {
          tittle: "CRM",
          hasSubRoute: false,
          showSubRoute: false,
          route: "crm/dashboard",
        },
        {
          tittle: "Production",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/bom/dashboard",
        },

        {
          tittle: "Admin",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/landingpage",
        },
        {
          tittle: "Misc",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/landingpage",
        },
        {
          tittle: "Gallary",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/landingpage",
        },
      ],
    },
    {
      tittle: "Roll call",
      hasSubRoute: false,
      icon: "users",
      showSubRoute: false,
      route: "/rollcall/dashboard",
    },
    {
      tittle: "Pay roll",
      hasSubRoute: false,
      icon: "users",
      showSubRoute: false,
      route: "/payroll/dashboard",
    },
    {
      tittle: "Application Tracking",
      hasSubRoute: false,
      icon: "users",
      showSubRoute: false,
      route: "/applicantTracking/dashboard",
    },
  ],

  rollcall: [
    {
      tittle: "Modules",
      hasSubRoute: true,
      icon: "layout-grid",
      showSubRoute: true,
      subRoutes: [
        // {
        //   tittle: "Rollcall",
        //   hasSubRoute: false,
        //   showSubRoute: false,
        //   route: "/rollcall/dashboard",
        // },
        // {
        //   tittle: "Payroll",
        //   hasSubRoute: false,
        //   showSubRoute: false,
        //   route: "/payroll/dashboard",
        // },
        // {
        //   tittle: "Applicant Tracking",
        //   hasSubRoute: false,
        //   showSubRoute: false,
        //   base: "application",
        //   route: "applicantTracking/dashboard",
        // },
        {
          tittle: "HR",
          hasSubRoute: false,
          icon: "layout-grid",
          showSubRoute: false,
          route: "/hr",
          // subRoutes: [
          //   {
          //     tittle: "Rollcall",
          //     hasSubRoute: false,
          //     showSubRoute: false,
          //     route: "/rollcall/dashboard",
          //   },
          //   {
          //     tittle: "Payroll",
          //     hasSubRoute: false,
          //     showSubRoute: false,
          //     route: "/payroll/dashboard",
          //   },
          //   {
          //     tittle: "Applicant Tracking",
          //     hasSubRoute: false,
          //     showSubRoute: false,
          //     base: "application",
          //     route: "applicantTracking/dashboard",
          //   },
          // ],
        },
        {
          tittle: "Inventory",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/inventory/dashboard",
          subRoutes: [],
        },
        {
          tittle: "Asset Management",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/assetmgt/dashboard",
        },
        {
          tittle: "Project Management",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/projectmgt/dashboard",
        },
        {
          tittle: "CRM",
          hasSubRoute: false,
          showSubRoute: false,
          route: "crm/dashboard",
        },
        {
          tittle: "Production",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/bom/dashboard",
        },

        {
          tittle: "Admin",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/landingpage",
        },
        {
          tittle: "Misc",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/landingpage",
        },
        {
          tittle: "Gallary",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/landingpage",
        },
      ],
    },
    // {
    //   tittle: "Dash Board",
    //   hasSubRoute: false,
    //   icon: "layout-grid",
    //   showSubRoute: false,
    //   route: "/rollcall/dashboard",
    // },
    {
      tittle: "Employee",
      hasSubRoute: true,
      icon: "users",
      showSubRoute: false,

      subRoutes: [
        {
          tittle: "Show All",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/rollcall/employees",
          subRoutes: [],
        },
        {
          tittle: "Additional Details",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/rollcall/additional-details",
          subRoutes: [],
        },
      ],
    },
    {
      tittle: "Permission",
      hasSubRoute: true,
      icon: "progress-check",
      showSubRoute: false,
      route: "/rollcall/manual-attendance",
      subRoutes: [
        {
          tittle: "Manual Attendance",
          hasSubRoute: false,
          showSubRoute: true,
          route: "/rollcall/manual-attendance",
          subRoutes: [],
        },
        {
          tittle: "Assign shift",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/rollcall/assign-shifts",
          subRoutes: [],
        },
        {
          tittle: "Employee Acess",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/rollcall/employee-access",
          subRoutes: [],
        },
        {
          tittle: "Registrations",
          hasSubRoute: false,
          showSubRoute: true,
          route: "/rollcall/registrations",
          subRoutes: [],
        },
        {
          tittle: "Rejoin Employes",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/rollcall/rejoin-employees",
          subRoutes: [],
        },
      ],
    },
    {
      tittle: "Configrations",
      hasSubRoute: true,
      icon: "settings-cog",
      showSubRoute: false,
      // activeRoute: 'Registrations',
      subRoutes: [
        {
          tittle: "Holidays",
          hasSubRoute: false,
          showSubRoute: true,
          route: "/rollcall/holidays",
          subRoutes: [],
        },
        {
          tittle: "Department",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/rollcall/departments",
          subRoutes: [],
        },
        {
          tittle: "Leave Type",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/rollcall/leavetypes",
          subRoutes: [],
        },

        // {
        //   tittle: "User Acess",
        //   hasSubRoute: false,
        //   showSubRoute: false,
        //   route: "/rollcall/employee",
        //   subRoutes: [],
        // },
      ],
    },
    // {
    //   tittle: "Monthly Reports",
    //   hasSubRoute: true,
    //   icon: "chart-line",
    //   showSubRoute: false,
    //   // activeRoute: 'Registrations',
    //   subRoutes: [
    //     {
    //       tittle: "Monthly Register",
    //       hasSubRoute: false,
    //       showSubRoute: true,
    //       route: "/rollcall/holidays",
    //       subRoutes: [],
    //     },
    //     {
    //       tittle: "Monthly Summary",
    //       hasSubRoute: false,
    //       showSubRoute: false,
    //       route: "rollcall/reports/706",
    //       subRoutes: [],
    //     },
    //     {
    //       tittle: "Leave Details",
    //       hasSubRoute: false,
    //       showSubRoute: false,
    //       route: "rollcall/reports/707",
    //       subRoutes: [],
    //     },
    //   ],
    // },
    {
      tittle: "Leave Management",
      hasSubRoute: true,
      icon: "calendar",
      showSubRoute: false,
      // activeRoute: 'Registrations',
      subRoutes: [
        {
          tittle: "Apply ",
          hasSubRoute: false,
          showSubRoute: true,
          route: "/rollcall/leaves",
          subRoutes: [],
        },
        {
          tittle: " Summary",
          hasSubRoute: false,
          showSubRoute: true,
          route: "/rollcall/leavesummary",
          subRoutes: [],
        },
        {
          tittle: " Accruals",
          hasSubRoute: false,
          showSubRoute: true,
          route: "/rollcall/leaveaccurals",
          subRoutes: [],
        },
        {
          tittle: " Report",
          hasSubRoute: false,
          showSubRoute: false,
          route: "rollcall/reports/707",
          subRoutes: [],
        },
      ],
    },
    {
      tittle: "Reports",
      hasSubRoute: true,
      icon: "chart-line",
      showSubRoute: false,
      subRoutes: [
        {
          tittle: "Day",
          hasSubRoute: true,
          icon: "chart-line",
          showSubRoute: false,
          activeRoute: "rollcall/reports/701",
          subRoutes: [
            {
              tittle: "Punch by Day",
              hasSubRoute: false,
              showSubRoute: true,
              route: "rollcall/reports/701",
              subRoutes: [],
            },
            {
              tittle: "Daily Attendance",
              hasSubRoute: false,
              showSubRoute: false,
              route: "rollcall/reports/702",
              subRoutes: [],
            },
            {
              tittle: "Break Summary",
              hasSubRoute: false,
              showSubRoute: false,
              route: "rollcall/reports/703",
              subRoutes: [],
            },
            {
              tittle: "Break Details",
              hasSubRoute: false,
              showSubRoute: false,
              route: "rollcall/reports/704",
              subRoutes: [],
            },
            {
              tittle: "Break Alerts",
              hasSubRoute: false,
              showSubRoute: false,
              route: "rollcall/reports/704",
              subRoutes: [],
            },
            {
              tittle: "Attendance In/Out",
              hasSubRoute: false,
              showSubRoute: false,
              route: "rollcall/reports/705",
              subRoutes: [],
            },
            {
              tittle: "Mobile Swipes",
              hasSubRoute: false,
              showSubRoute: false,
              route: "rollcall/reports/704",
              subRoutes: [],
            },
            {
              tittle: "Wage Details",
              hasSubRoute: false,
              showSubRoute: false,
              route: "rollcall/reports/704",
              subRoutes: [],
            },
            {
              tittle: "Wage Summary",
              hasSubRoute: false,
              showSubRoute: false,
              route: "rollcall/reports/705",
              subRoutes: [],
            },
            // {
            //   tittle: "Monthly Summary",
            //   hasSubRoute: false,
            //   showSubRoute: false,
            //   route: "rollcall/reports/706",
            //   subRoutes: [],
            // },
            // {
            //   tittle: "Monthly Register",
            //   hasSubRoute: false,
            //   showSubRoute: true,
            //   route: "/rollcall/holidays",
            //   subRoutes: [],
            // },
            // {
            //   tittle: "Monthly Summary",
            //   hasSubRoute: false,
            //   showSubRoute: false,
            //   route: "rollcall/reports/706",
            //   subRoutes: [],
            // },
          ],
        },
        {
          tittle: "Monthly",
          hasSubRoute: true,
          icon: "chart-line",
          showSubRoute: false,
          activeRoute: "rollcall/reports/701",
          subRoutes: [
            {
              tittle: "Monthly Summary",
              hasSubRoute: false,
              showSubRoute: false,
              route: "rollcall/reports/706",
              subRoutes: [],
            },
            // {
            //   tittle: "Monthly Summary",
            //   hasSubRoute: false,
            //   showSubRoute: false,
            //   route: "rollcall/reports/706",
            //   subRoutes: [],
            // },
            {
              tittle: "Monthly Register",
              hasSubRoute: false,
              showSubRoute: true,
              route: "rollcall/reports/706",
              subRoutes: [],
            },
          ],
        },
      ],
    },
  ],

  payroll: [
    {
      tittle: "Modules",
      hasSubRoute: true,
      icon: "layout-grid",
      showSubRoute: true,
      subRoutes: [
        // {
        //   tittle: "Rollcall",
        //   hasSubRoute: false,
        //   showSubRoute: false,
        //   route: "/rollcall/dashboard",
        // },
        // {
        //   tittle: "Payroll",
        //   hasSubRoute: false,
        //   showSubRoute: false,
        //   route: "/payroll/dashboard",
        // },
        // {
        //   tittle: "Applicant Tracking",
        //   hasSubRoute: false,
        //   showSubRoute: false,
        //   base: "application",
        //   route: "applicantTracking/dashboard",
        // },
        {
          tittle: "HR",
          hasSubRoute: false,
          icon: "layout-grid",
          showSubRoute: false,
          route: "/hr",
          // subRoutes: [
          //   {
          //     tittle: "Rollcall",
          //     hasSubRoute: false,
          //     showSubRoute: false,
          //     route: "/rollcall/dashboard",
          //   },
          //   {
          //     tittle: "Payroll",
          //     hasSubRoute: false,
          //     showSubRoute: false,
          //     route: "/payroll/dashboard",
          //   },
          //   {
          //     tittle: "Applicant Tracking",
          //     hasSubRoute: false,
          //     showSubRoute: false,
          //     base: "application",
          //     route: "applicantTracking/dashboard",
          //   },
          // ],
        },
        {
          tittle: "Inventory",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/inventory/dashboard",
          subRoutes: [],
        },
        {
          tittle: "Asset Management",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/assetmgt/dashboard",
        },
        {
          tittle: "Project Management",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/projectmgt/dashboard",
        },
        {
          tittle: "CRM",
          hasSubRoute: false,
          showSubRoute: false,
          route: "crm/dashboard",
        },
        {
          tittle: "Production",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/bom/dashboard",
        },

        {
          tittle: "Admin",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/landingpage",
        },
        {
          tittle: "Misc",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/landingpage",
        },
        {
          tittle: "Gallary",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/landingpage",
        },
      ],
    },
    // {
    //   tittle: "Dash Board",
    //   hasSubRoute: false,
    //   icon: "layout-grid",
    //   showSubRoute: false,
    //   route: "/payroll/dashboard",
    // },
    {
      tittle: "Employee",
      hasSubRoute: true,
      icon: "users",
      showSubRoute: false,

      subRoutes: [
        {
          tittle: "Employe List",
          hasSubRoute: false,
          showSubRoute: true,
          route: "/payroll/employeeslist",
          subRoutes: [],
        },
        {
          tittle: "Employee Ctc",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/payroll/employeesctc",
          subRoutes: [],
        },
      ],
    },
    // {
    //   tittle: 'Manual Attandance',
    //   hasSubRoute: false,
    //   icon: 'layout-grid',
    //   showSubRoute: false,
    //   route: "/rollcall/manual-attendance"
    // },
    {
      tittle: "Compensation",
      hasSubRoute: true,
      icon: "cash",
      showSubRoute: false,
      // activeRoute: 'Registrations',
      subRoutes: [
        {
          tittle: "Salary Breakup",
          hasSubRoute: false,
          showSubRoute: true,
          route: "/payroll/salarybreakup",
          subRoutes: [],
        },
        {
          tittle: "Salary incenstives",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/payroll/salarybreakup",
          subRoutes: [],
        },
        {
          tittle: "Advances",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/payroll/advance",
          subRoutes: [],
        },
        {
          tittle: "advance adjustments",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/payroll/advance",
          subRoutes: [],
        },
      ],
    },
    {
      tittle: "Reports",
      hasSubRoute: true,
      icon: "chart-pie",
      showSubRoute: false,
      // activeRoute: 'Registrations',
      subRoutes: [
        {
          tittle: "Salary Report",
          hasSubRoute: false,
          showSubRoute: true,
          route: "/payroll/reports/601",
          subRoutes: [],
        },
        {
          tittle: "Pf Report",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/payroll/reports/602",
          subRoutes: [],
        },
        // {
        //   tittle: "Esi Report",
        //   hasSubRoute: false,
        //   showSubRoute: false,
        //   route: "/payroll/reports/:id",
        //   subRoutes: [],
        // },
        // {
        //   tittle: "Pay slip",
        //   hasSubRoute: false,
        //   showSubRoute: false,
        //   route: "/payroll/reports/",
        //   subRoutes: [],
        // },
        {
          tittle: "bank Statement",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/payroll/reports/603",
          subRoutes: [],
        },

        {
          tittle: "Advances reports",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/payroll/reports/604",
          subRoutes: [],
        },
      ],
    },
    {
      tittle: "Settings",
      hasSubRoute: true,
      icon: "settings-cog",
      showSubRoute: false,
      // activeRoute: 'Registrations',
      subRoutes: [
        {
          tittle: "Process Payroll",
          hasSubRoute: false,
          showSubRoute: true,
          route: "/payroll/advance",
          subRoutes: [],
        },

        {
          tittle: "Pay List",
          hasSubRoute: false,
          showSubRoute: true,
          route: "/payroll/advance",
          subRoutes: [],
        },
        {
          tittle: "Receiver Payment",
          hasSubRoute: false,
          showSubRoute: true,
          route: "/payroll/advance",
          subRoutes: [],
        },
      ],
    },
  ],

  applicantTracking: [
    {
      tittle: "Modules",
      hasSubRoute: true,
      icon: "layout-grid",
      showSubRoute: true,
      subRoutes: [
        // {
        //   tittle: "Rollcall",
        //   hasSubRoute: false,
        //   showSubRoute: false,
        //   route: "/rollcall/dashboard",
        // },
        // {
        //   tittle: "Payroll",
        //   hasSubRoute: false,
        //   showSubRoute: false,
        //   route: "/payroll/dashboard",
        // },
        // {
        //   tittle: "Applicant Tracking",
        //   hasSubRoute: false,
        //   showSubRoute: false,
        //   base: "application",
        //   route: "applicantTracking/dashboard",
        // },
        {
          tittle: "HR",
          hasSubRoute: false,
          icon: "layout-grid",
          showSubRoute: false,
          route: "/hr",
          // subRoutes: [
          //   {
          //     tittle: "Rollcall",
          //     hasSubRoute: false,
          //     showSubRoute: false,
          //     route: "/rollcall/dashboard",
          //   },
          //   {
          //     tittle: "Payroll",
          //     hasSubRoute: false,
          //     showSubRoute: false,
          //     route: "/payroll/dashboard",
          //   },
          //   {
          //     tittle: "Applicant Tracking",
          //     hasSubRoute: false,
          //     showSubRoute: false,
          //     base: "application",
          //     route: "applicantTracking/dashboard",
          //   },
          // ],
        },
        {
          tittle: "Inventory",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/inventory/dashboard",
          subRoutes: [],
        },
        {
          tittle: "Asset Management",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/assetmgt/dashboard",
        },
        {
          tittle: "Project Management",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/projectmgt/dashboard",
        },
        {
          tittle: "CRM",
          hasSubRoute: false,
          showSubRoute: false,
          route: "crm/dashboard",
        },
        {
          tittle: "Production",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/bom/dashboard",
        },

        {
          tittle: "Admin",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/landingpage",
        },
        {
          tittle: "Misc",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/landingpage",
        },
        {
          tittle: "Gallary",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/landingpage",
        },
      ],
    },
    // {
    //   tittle: "Dash Board",
    //   hasSubRoute: false,
    //   icon: "layout-grid",
    //   showSubRoute: false,
    //   route: "/applicantTracking/dashboard",
    // },
    {
      tittle: "Applicants",
      hasSubRoute: false,
      icon: "users",
      showSubRoute: false,
      route: "/applicantTracking/applicants",
    },
    {
      tittle: "Clients",
      hasSubRoute: false,
      icon: "users",
      showSubRoute: false,
      route: "/applicantTracking/clients",
    },
    {
      tittle: "Jobs posted",
      hasSubRoute: false,
      icon: "clipboard-list",
      showSubRoute: false,
      route: "/applicantTracking/jobs",
    },
    {
      tittle: "Settings",
      hasSubRoute: true,
      icon: "settings-cog",
      showSubRoute: false,
      // route: "/applicantTracking/jobs",
      subRoutes: [
        {
          tittle: "Job Categories",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/applicantTracking/jobcategories",
          subRoutes: [],
        },
        {
          tittle: "Job Skills",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/applicantTracking/jobskills",
        },
        {
          tittle: "Placements",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/applicantTracking/placements",
        },
        {
          tittle: "Email Notfication",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/applicantTracking/emailnotfication",
        },
        {
          tittle: "Interview Feedback",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/applicantTracking/interviewfeedback",
        },
      ],
    },
  ],

  inventory: [
    {
      tittle: "Modules",
      hasSubRoute: true,
      icon: "layout-grid",
      showSubRoute: true,
      subRoutes: [
        // {
        //   tittle: "Rollcall",
        //   hasSubRoute: false,
        //   showSubRoute: false,
        //   route: "/rollcall/dashboard",
        // },
        // {
        //   tittle: "Payroll",
        //   hasSubRoute: false,
        //   showSubRoute: false,
        //   route: "/payroll/dashboard",
        // },
        // {
        //   tittle: "Applicant Tracking",
        //   hasSubRoute: false,
        //   showSubRoute: false,
        //   base: "application",
        //   route: "applicantTracking/dashboard",
        // },
        {
          tittle: "HR",
          hasSubRoute: false,
          icon: "layout-grid",
          showSubRoute: false,
          route: "/hr",
          // subRoutes: [
          //   {
          //     tittle: "Rollcall",
          //     hasSubRoute: false,
          //     showSubRoute: false,
          //     route: "/rollcall/dashboard",
          //   },
          //   {
          //     tittle: "Payroll",
          //     hasSubRoute: false,
          //     showSubRoute: false,
          //     route: "/payroll/dashboard",
          //   },
          //   {
          //     tittle: "Applicant Tracking",
          //     hasSubRoute: false,
          //     showSubRoute: false,
          //     base: "application",
          //     route: "applicantTracking/dashboard",
          //   },
          // ],
        },
        {
          tittle: "Inventory",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/inventory/dashboard",
          subRoutes: [],
        },
        {
          tittle: "Asset Management",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/assetmgt/dashboard",
        },
        {
          tittle: "Project Management",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/projectmgt/dashboard",
        },
        {
          tittle: "CRM",
          hasSubRoute: false,
          showSubRoute: false,
          route: "crm/dashboard",
        },
        {
          tittle: "Production",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/bom/dashboard",
        },

        {
          tittle: "Admin",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/landingpage",
        },
        {
          tittle: "Misc",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/landingpage",
        },
        {
          tittle: "Gallary",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/landingpage",
        },
      ],
    },
    // {
    //   tittle: "Dash Board",
    //   hasSubRoute: false,
    //   icon: "layout-grid",
    //   showSubRoute: false,
    //   route: "/inventory/dashboard",
    // },
    {
      tittle: "Purchases",
      hasSubRoute: true,
      icon: "clipboard-list",
      showSubRoute: false,
      subRoutes: [
        {
          tittle: "Supplier",
          hasSubRoute: false,
          showSubRoute: true,
          route: "/inventory/suppliers",
          subRoutes: [],
        },
        {
          tittle: "Purchase Request",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/inventory/purchase-request",
          subRoutes: [],
        },
        {
          tittle: "Purchase Order",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/inventory/purchase-list",
          subRoutes: [],
        },
        {
          tittle: "Invoice",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/inventory/invoice-list",
          subRoutes: [],
        },
        {
          tittle: "Supplier Payment",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/inventory/supplier-payments",
          subRoutes: [],
        },
      ],
    },

    // {
    //   tittle: 'Stock',
    //   hasSubRoute: false,
    //   icon: 'layout-grid',
    //   showSubRoute: false,
    //   route: "/rollcall/manual-attendance"
    // },
    // {
    //   tittle: 'Assign shift',
    //   hasSubRoute: false,
    //   icon: 'layout-grid',
    //   showSubRoute: false,
    //   route: "/rollcall/assign-shifts",
    // },
    {
      tittle: "Stock",
      hasSubRoute: true,
      icon: "file-search",
      showSubRoute: false,

      subRoutes: [
        {
          tittle: "Indent",
          hasSubRoute: false,
          showSubRoute: true,
          route: "/inventory/indent",
          subRoutes: [],
        },
        {
          tittle: "Local Purchase indents",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/inventory/local-indent/",
          subRoutes: [],
        },
        {
          tittle: "Transfer",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/inventory/stock-transfer",
          subRoutes: [],
        },
        {
          tittle: "Adjustment",
          hasSubRoute: false,
          showSubRoute: false,
          route: "inventory/stock-adjustment",
          subRoutes: [],
        },
      ],
    },

    {
      tittle: "Inventory Reports",
      hasSubRoute: true,
      icon: "chart-line",
      showSubRoute: false,

      subRoutes: [
        {
          tittle: "Stock Reports",
          hasSubRoute: true,
          showSubRoute: true,
          subRoutes: [
            {
              tittle: "Low Stock",
              hasSubRoute: false,
              showSubRoute: false,
              route: "/inventory/reports/301",
              subRoutes: [],
            },
            {
              tittle: "Current Stock",
              hasSubRoute: false,
              showSubRoute: false,
              route: "/inventory/reports/302",
              subRoutes: [],
            },
            {
              tittle: "Stock Worth",
              hasSubRoute: false,
              showSubRoute: false,
              route: "/inventory/reports/303",
              subRoutes: [],
            },
            {
              tittle: "Short Supply",
              hasSubRoute: false,
              showSubRoute: false,
              route: "/inventory/reports/304",
              subRoutes: [],
            },
          ],
        },
        {
          tittle: "Inventory Reports",
          hasSubRoute: true,
          showSubRoute: true,
          subRoutes: [
            {
              tittle: "Request By product",
              hasSubRoute: false,
              showSubRoute: false,
              route: "/inventory/reports/501",
              subRoutes: [],
            },
            {
              tittle: "Purchase Request",
              hasSubRoute: false,
              showSubRoute: false,
              route: "/inventory/reports/502",
              subRoutes: [],
            },
            {
              tittle: "Purchase request Details",
              hasSubRoute: false,
              showSubRoute: false,
              route: "/inventory/reports/503",
              subRoutes: [],
            },
            {
              tittle: "Purchase Order",
              hasSubRoute: false,
              showSubRoute: false,
              route: "/inventory/reports/504",
              subRoutes: [],
            },
            {
              tittle: "Purchase Order Details",
              hasSubRoute: false,
              showSubRoute: false,
              route: "/inventory/reports/505",
              subRoutes: [],
            },
            {
              tittle: "Purchase Invoice",
              hasSubRoute: false,
              showSubRoute: false,
              route: "/inventory/reports/506",
              subRoutes: [],
            },
            {
              tittle: "Purchase Invoice details",
              hasSubRoute: false,
              showSubRoute: false,
              route: "/inventory/reports/507",
              subRoutes: [],
            },
          ],
        },
        {
          tittle: "Indent Reports",
          hasSubRoute: true,
          showSubRoute: true,
          subRoutes: [
            {
              tittle: "Indent By City",
              hasSubRoute: false,
              showSubRoute: false,
              route: "/inventory/reports/401",
              subRoutes: [],
            },
            {
              tittle: "Indent By Store",
              hasSubRoute: false,
              showSubRoute: false,
              route: "/inventory/reports/402",
              subRoutes: [],
            },
            {
              tittle: "All Indents",
              hasSubRoute: false,
              showSubRoute: false,
              route: "/inventory/reports/403",
              subRoutes: [],
            },
            {
              tittle: "Local Indents",
              hasSubRoute: false,
              showSubRoute: false,
              route: "/inventory/reports/404",
              subRoutes: [],
            },
          ],
        },
      ],
    },
    {
      tittle: "Master",
      hasSubRoute: true,
      icon: "package ",
      showSubRoute: false,

      subRoutes: [
        {
          tittle: "Category",
          hasSubRoute: false,
          showSubRoute: true,
          route: "/inventory/category",
          subRoutes: [],
        },
        {
          tittle: "Sub Category",
          hasSubRoute: false,
          showSubRoute: true,
          route: "/inventory/subcategory",
          subRoutes: [],
        },
      ],
    },
  ],

  bom: [
    {
      tittle: "Modules",
      hasSubRoute: true,
      icon: "layout-grid",
      showSubRoute: true,
      subRoutes: [
        // {
        //   tittle: "Rollcall",
        //   hasSubRoute: false,
        //   showSubRoute: false,
        //   route: "/rollcall/dashboard",
        // },
        // {
        //   tittle: "Payroll",
        //   hasSubRoute: false,
        //   showSubRoute: false,
        //   route: "/payroll/dashboard",
        // },
        // {
        //   tittle: "Applicant Tracking",
        //   hasSubRoute: false,
        //   showSubRoute: false,
        //   base: "application",
        //   route: "applicantTracking/dashboard",
        // },
        {
          tittle: "HR",
          hasSubRoute: false,
          icon: "layout-grid",
          showSubRoute: false,
          route: "/hr",
          // subRoutes: [
          //   {
          //     tittle: "Rollcall",
          //     hasSubRoute: false,
          //     showSubRoute: false,
          //     route: "/rollcall/dashboard",
          //   },
          //   {
          //     tittle: "Payroll",
          //     hasSubRoute: false,
          //     showSubRoute: false,
          //     route: "/payroll/dashboard",
          //   },
          //   {
          //     tittle: "Applicant Tracking",
          //     hasSubRoute: false,
          //     showSubRoute: false,
          //     base: "application",
          //     route: "applicantTracking/dashboard",
          //   },
          // ],
        },
        {
          tittle: "Inventory",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/inventory/dashboard",
          subRoutes: [],
        },
        {
          tittle: "Asset Management",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/assetmgt/dashboard",
        },
        {
          tittle: "Project Management",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/projectmgt/dashboard",
        },
        {
          tittle: "CRM",
          hasSubRoute: false,
          showSubRoute: false,
          route: "crm/dashboard",
        },
        {
          tittle: "Production",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/bom/dashboard",
        },

        {
          tittle: "Admin",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/landingpage",
        },
        {
          tittle: "Misc",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/landingpage",
        },
        {
          tittle: "Gallary",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/landingpage",
        },
      ],
    },
    // {
    //   tittle: "Dash Board",
    //   hasSubRoute: false,
    //   icon: "layout-grid",
    //   showSubRoute: false,
    //   route: "/bom/dashboard",
    // },
    {
      tittle: "Bom",
      hasSubRoute: false,
      icon: "device-analytics",
      showSubRoute: false,
      route: "/bom/bomlist",
    },
    {
      tittle: "Item",
      hasSubRoute: false,
      icon: "brand-hipchat",
      showSubRoute: false,
      route: "/bom/itemslist",
    },
    {
      tittle: "Job Card",
      hasSubRoute: false,
      icon: "clipboard-list",
      showSubRoute: false,
      route: "/bom/jobcardlist",
    },
    {
      tittle: "Package",
      hasSubRoute: false,
      icon: "package ",
      showSubRoute: false,
      route: "/bom/packages",
    },
    {
      tittle: "Check Availability",
      hasSubRoute: false,
      icon: "search",
      showSubRoute: false,
      route: "/bom/checkavailability",
    },
  ],

  assetmgt: [
    {
      tittle: "Modules",
      hasSubRoute: true,
      icon: "layout-grid",
      showSubRoute: true,
      subRoutes: [
        // {
        //   tittle: "Rollcall",
        //   hasSubRoute: false,
        //   showSubRoute: false,
        //   route: "/rollcall/dashboard",
        // },
        // {
        //   tittle: "Payroll",
        //   hasSubRoute: false,
        //   showSubRoute: false,
        //   route: "/payroll/dashboard",
        // },
        // {
        //   tittle: "Applicant Tracking",
        //   hasSubRoute: false,
        //   showSubRoute: false,
        //   base: "application",
        //   route: "applicantTracking/dashboard",
        // },
        {
          tittle: "HR",
          hasSubRoute: false,
          icon: "layout-grid",
          showSubRoute: false,
          route: "/hr",
          // subRoutes: [
          //   {
          //     tittle: "Rollcall",
          //     hasSubRoute: false,
          //     showSubRoute: false,
          //     route: "/rollcall/dashboard",
          //   },
          //   {
          //     tittle: "Payroll",
          //     hasSubRoute: false,
          //     showSubRoute: false,
          //     route: "/payroll/dashboard",
          //   },
          //   {
          //     tittle: "Applicant Tracking",
          //     hasSubRoute: false,
          //     showSubRoute: false,
          //     base: "application",
          //     route: "applicantTracking/dashboard",
          //   },
          // ],
        },
        {
          tittle: "Inventory",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/inventory/dashboard",
          subRoutes: [],
        },
        {
          tittle: "Asset Management",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/assetmgt/dashboard",
        },
        {
          tittle: "Project Management",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/projectmgt/dashboard",
        },
        {
          tittle: "CRM",
          hasSubRoute: false,
          showSubRoute: false,
          route: "crm/dashboard",
        },
        {
          tittle: "Production",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/bom/dashboard",
        },

        {
          tittle: "Admin",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/landingpage",
        },
        {
          tittle: "Misc",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/landingpage",
        },
        {
          tittle: "Gallary",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/landingpage",
        },
      ],
    },
    // {
    //   tittle: "Dash Board",
    //   hasSubRoute: false,
    //   icon: "layout-grid",
    //   showSubRoute: false,
    //   route: "/assetmgt/dashboard",
    // },
    {
      tittle: "Assets",
      hasSubRoute: true,
      icon: "folder-open",
      showSubRoute: true,
      subRoutes: [
        // {
        //   tittle: "HR",
        //   hasSubRoute: true,
        //   icon: "layout-grid",
        //   showSubRoute: false,
        //   subRoutes: [
        //     {
        //       tittle: "Rollcall",
        //       hasSubRoute: false,
        //       showSubRoute: false,
        //       route: '/rollcall/dashboard',
        //     },
        //     {
        //       tittle: "Payroll",
        //       hasSubRoute: false,
        //       showSubRoute: false,
        //       route: '/payroll/dashboard',
        //     },
        //     {
        //       tittle: "Applicant Tracking",
        //       hasSubRoute: false,
        //       showSubRoute: false,
        //       base: "application",
        //       route: 'applicantTracking/dashboard',
        //     },
        //   ],
        // },
        {
          tittle: "Assets",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/assetmgt/assets",
          subRoutes: [],
        },
        {
          tittle: "Using Assets",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/assetmgt/using",
        },
        {
          tittle: "Unused Assets",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/assetmgt/unused",
        },
        {
          tittle: "Broken Assets",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/assetmgt/broken",
        },
        {
          tittle: "Lost Assets",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/assetmgt/lost",
        },
        {
          tittle: "Assets Details",
          hasSubRoute: false,
          showSubRoute: false,
          route: "assetmgt/assetdetails",
        },
      ],
    },
    // {
    //   tittle: "Assets",
    //   hasSubRoute: false,
    //   icon: "users",
    //   showSubRoute: false,
    //   route: "/assetmgt/assets",
    // },
    {
      tittle: "Liquidation",
      hasSubRoute: false,
      icon: "device-analytics",
      showSubRoute: false,
      route: "/assetmgt/liquidation",
    },
    {
      tittle: "Warranty Repair",
      hasSubRoute: false,
      icon: "settings-cog",
      showSubRoute: false,
      route: "/assetmgt/warrantyrepair",
    },
    {
      tittle: "Suppliers",
      hasSubRoute: false,
      icon: "clipboard-list",
      showSubRoute: false,
      route: "/assetmgt/suppliers",
    },
  ],

  crm: [
    {
      tittle: "Modules",
      hasSubRoute: true,
      icon: "layout-grid",
      showSubRoute: true,
      subRoutes: [
        // {
        //   tittle: "Rollcall",
        //   hasSubRoute: false,
        //   showSubRoute: false,
        //   route: "/rollcall/dashboard",
        // },
        // {
        //   tittle: "Payroll",
        //   hasSubRoute: false,
        //   showSubRoute: false,
        //   route: "/payroll/dashboard",
        // },
        // {
        //   tittle: "Applicant Tracking",
        //   hasSubRoute: false,
        //   showSubRoute: false,
        //   base: "application",
        //   route: "applicantTracking/dashboard",
        // },
        {
          tittle: "HR",
          hasSubRoute: false,
          icon: "layout-grid",
          showSubRoute: false,
          route: "/hr",
          // subRoutes: [
          //   {
          //     tittle: "Rollcall",
          //     hasSubRoute: false,
          //     showSubRoute: false,
          //     route: "/rollcall/dashboard",
          //   },
          //   {
          //     tittle: "Payroll",
          //     hasSubRoute: false,
          //     showSubRoute: false,
          //     route: "/payroll/dashboard",
          //   },
          //   {
          //     tittle: "Applicant Tracking",
          //     hasSubRoute: false,
          //     showSubRoute: false,
          //     base: "application",
          //     route: "applicantTracking/dashboard",
          //   },
          // ],
        },
        {
          tittle: "Inventory",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/inventory/dashboard",
          subRoutes: [],
        },
        {
          tittle: "Asset Management",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/assetmgt/dashboard",
        },
        {
          tittle: "Project Management",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/projectmgt/dashboard",
        },
        {
          tittle: "CRM",
          hasSubRoute: false,
          showSubRoute: false,
          route: "crm/dashboard",
        },
        {
          tittle: "Production",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/bom/dashboard",
        },

        {
          tittle: "Admin",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/landingpage",
        },
        {
          tittle: "Misc",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/landingpage",
        },
        {
          tittle: "Gallary",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/landingpage",
        },
      ],
    },
    // {
    //   tittle: "Dash Board",
    //   hasSubRoute: false,
    //   icon: "layout-grid",
    //   showSubRoute: false,
    //   route: "/crm/dashboard",
    // },

    {
      tittle: "Leads",
      hasSubRoute: false,
      icon: "users",
      showSubRoute: false,
      route: "/crm/leads",
    },
    {
      tittle: "Customers",
      hasSubRoute: false,
      icon: "users",
      showSubRoute: false,
      route: "/crm/customers",
    },
    {
      tittle: "Products",
      hasSubRoute: false,
      icon: "package",
      showSubRoute: false,
      // route: "/assetmgt/warrantyrepair",
    },
    {
      tittle: "Projects",
      hasSubRoute: false,
      icon: "users",
      showSubRoute: false,
      // route: "/assetmgt/suppliers",
    },
    {
      tittle: "Expenses",
      hasSubRoute: false,
      icon: "users",
      showSubRoute: false,
      route: "/crm/expenses",
    },
    {
      tittle: "Sales",
      hasSubRoute: true,
      icon: "trending-up",
      showSubRoute: true,
      subRoutes: [
        {
          tittle: "Proposal",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/crm/proposals",
        },
        {
          tittle: "Estimate",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/crm/estimates",
        },
        {
          tittle: "Invoice",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/crm/invoices",
          subRoutes: [],
        },
        {
          tittle: "Credit Notes",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/crm/creditnotes",
        },
        {
          tittle: "Payments",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/crm/payments",
        },
      ],
    },
    // {
    //   tittle: "Reports",
    //   hasSubRoute: true,
    //   icon: "chart-line",
    //   showSubRoute: true,
    //   subRoutes: [
    //     {
    //       tittle: "Leads ",
    //       hasSubRoute: false,
    //       showSubRoute: false,
    //       // route: "/assetmgt/assets",
    //       subRoutes: [],
    //     },
    //     {
    //       tittle: "Customers ",
    //       hasSubRoute: false,
    //       showSubRoute: false,
    //       // route: '/assetmgt/using',
    //     },
    //   ],
    // },
  ],

  projectmgt: [
    {
      tittle: "Modules",
      hasSubRoute: true,
      icon: "layout-grid",
      showSubRoute: true,
      subRoutes: [
        // {
        //   tittle: "Rollcall",
        //   hasSubRoute: false,
        //   showSubRoute: false,
        //   route: "/rollcall/dashboard",
        // },
        // {
        //   tittle: "Payroll",
        //   hasSubRoute: false,
        //   showSubRoute: false,
        //   route: "/payroll/dashboard",
        // },
        // {
        //   tittle: "Applicant Tracking",
        //   hasSubRoute: false,
        //   showSubRoute: false,
        //   base: "application",
        //   route: "applicantTracking/dashboard",
        // },
        {
          tittle: "HR",
          hasSubRoute: false,
          icon: "layout-grid",
          showSubRoute: false,
          route: "/hr",
          // subRoutes: [
          //   {
          //     tittle: "Rollcall",
          //     hasSubRoute: false,
          //     showSubRoute: false,
          //     route: "/rollcall/dashboard",
          //   },
          //   {
          //     tittle: "Payroll",
          //     hasSubRoute: false,
          //     showSubRoute: false,
          //     route: "/payroll/dashboard",
          //   },
          //   {
          //     tittle: "Applicant Tracking",
          //     hasSubRoute: false,
          //     showSubRoute: false,
          //     base: "application",
          //     route: "applicantTracking/dashboard",
          //   },
          // ],
        },
        {
          tittle: "Inventory",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/inventory/dashboard",
          subRoutes: [],
        },
        {
          tittle: "Asset Management",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/assetmgt/dashboard",
        },
        {
          tittle: "Project Management",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/projectmgt/dashboard",
        },
        {
          tittle: "CRM",
          hasSubRoute: false,
          showSubRoute: false,
          route: "crm/dashboard",
        },
        {
          tittle: "Production",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/bom/dashboard",
        },

        {
          tittle: "Admin",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/landingpage",
        },
        {
          tittle: "Misc",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/landingpage",
        },
        {
          tittle: "Gallary",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/landingpage",
        },
      ],
    },
    {
      tittle: "Projects",
      hasSubRoute: false,
      icon: "layout-dashboard",
      showSubRoute: false,
      route: "/projectmgt/dashboard",
    },
    {
      tittle: "Tasks",
      hasSubRoute: false,
      icon: "clipboard-list",
      showSubRoute: false,
      route: "/crm/tasks",
    },
    {
      tittle: "Expenses",
      hasSubRoute: false,
      icon: "cash",
      showSubRoute: false,
      route: "/expense-list",
    },
    {
      tittle: "Time Sheet",
      hasSubRoute: false,
      icon: "calendar",
      showSubRoute: false,
      route: "/ui-timeline",
    },
  ],

  admin: [
    {
      tittle: "Modules",
      hasSubRoute: true,
      icon: "layout-grid",
      showSubRoute: true,
      subRoutes: [
        // {
        //   tittle: "Rollcall",
        //   hasSubRoute: false,
        //   showSubRoute: false,
        //   route: "/rollcall/dashboard",
        // },
        // {
        //   tittle: "Payroll",
        //   hasSubRoute: false,
        //   showSubRoute: false,
        //   route: "/payroll/dashboard",
        // },
        // {
        //   tittle: "Applicant Tracking",
        //   hasSubRoute: false,
        //   showSubRoute: false,
        //   base: "application",
        //   route: "applicantTracking/dashboard",
        // },
        {
          tittle: "HR",
          hasSubRoute: false,
          icon: "layout-grid",
          showSubRoute: false,
          route: "/hr",
          // subRoutes: [
          //   {
          //     tittle: "Rollcall",
          //     hasSubRoute: false,
          //     showSubRoute: false,
          //     route: "/rollcall/dashboard",
          //   },
          //   {
          //     tittle: "Payroll",
          //     hasSubRoute: false,
          //     showSubRoute: false,
          //     route: "/payroll/dashboard",
          //   },
          //   {
          //     tittle: "Applicant Tracking",
          //     hasSubRoute: false,
          //     showSubRoute: false,
          //     base: "application",
          //     route: "applicantTracking/dashboard",
          //   },
          // ],
        },
        {
          tittle: "Inventory",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/inventory/dashboard",
          subRoutes: [],
        },
        {
          tittle: "Asset Management",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/assetmgt/dashboard",
        },
        {
          tittle: "Project Management",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/projectmgt/dashboard",
        },
        {
          tittle: "CRM",
          hasSubRoute: false,
          showSubRoute: false,
          route: "crm/dashboard",
        },
        {
          tittle: "Production",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/bom/dashboard",
        },

        {
          tittle: "Admin",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/landingpage",
        },
        {
          tittle: "Misc",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/landingpage",
        },
        {
          tittle: "Gallary",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/landingpage",
        },
      ],
    },
    {
      tittle: "Products",
      hasSubRoute: false,
      icon: "layout-dashboard",
      showSubRoute: false,
      route: "/admin/products",
    },
    {
      tittle: "Holidays",
      hasSubRoute: false,
      icon: "layout-dashboard",
      showSubRoute: false,
      route: "/admin/holidays",
    },
  ],
};
